var _style, _g, _g2, _rect, _line, _line2, _line3, _line4, _line5, _rect2, _rect3, _polygon, _rect4, _rect5, _rect6, _rect7, _rect8, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _rect9, _defs, _g3, _rect10, _rect11, _rect12, _defs2, _g4, _rect13, _rect14, _rect15, _defs3, _g5, _rect16, _rect17, _rect18, _defs4, _g6, _rect19, _rect20, _rect21, _defs5, _g7, _rect22, _rect23, _rect24, _defs6, _g8, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _polygon2, _polygon3, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _defs7, _g9, _rect43, _rect44, _defs8, _g10, _rect45, _rect46, _defs9, _g11, _rect47, _rect48, _rect49, _defs10, _g12, _rect50, _rect51, _rect52, _defs11, _g13, _rect53, _rect54, _rect55, _defs12, _g14, _rect56, _rect57, _rect58, _defs13, _g15, _rect59, _rect60, _rect61, _defs14, _g16, _rect62, _rect63, _rect64, _defs15, _g17, _rect65, _rect66, _rect67, _defs16, _g18, _rect68, _rect69, _rect70, _defs17, _g19, _rect71, _rect72, _rect73, _defs18, _g20, _rect74, _rect75, _rect76, _defs19, _g21, _rect77, _rect78, _rect79, _defs20, _g22, _rect80, _rect81, _rect82, _defs21, _g23, _rect83, _rect84, _rect85, _defs22, _g24, _rect86, _rect87, _rect88, _defs23, _g25, _rect89, _rect90, _rect91, _defs24, _g26, _rect92, _rect93, _rect94, _defs25, _g27, _rect95, _rect96, _rect97, _defs26, _g28, _rect98, _rect99, _rect100, _defs27, _g29, _rect101, _rect102, _rect103, _defs28, _g30, _rect104, _rect105, _rect106, _defs29, _g31, _rect107, _rect108, _rect109, _defs30, _g32, _rect110, _rect111, _rect112, _defs31, _g33, _rect113, _rect114, _rect115, _defs32, _g34, _rect116, _rect117, _rect118, _defs33, _g35, _rect119, _rect120, _rect121, _defs34, _g36, _rect122, _rect123, _rect124, _defs35, _g37, _rect125, _rect126, _rect127, _defs36, _g38, _rect128, _rect129, _rect130, _defs37, _g39, _rect131, _rect132, _rect133, _defs38, _g40, _rect134, _rect135, _rect136, _rect137, _rect138, _rect139, _rect140, _rect141, _rect142, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _rect143, _rect144, _line36, _line37, _line38, _line39, _line40, _line41, _line42, _line43, _line44, _line45;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuildingBro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#6DA6E2;}\r\n\t.st1{opacity:0.7;}\r\n\t.st2{fill:#FFFFFF;}\r\n\t.st3{fill:#A1A2A6;}\r\n\t.st4{fill:#FFFFFF;stroke:#193638;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st5{fill:none;stroke:#193638;stroke-width:0.75;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st6{fill:#193638;stroke:#193638;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st7{fill:#798DA6;stroke:#193638;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st8{clip-path:url(#SVGID_00000007406474816889827190000014173798378105726608_);}\r\n\t.st9{opacity:0.6;}\r\n\t.st10{fill:#798DA6;}\r\n\t.st11{fill:none;stroke:#193638;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st12{clip-path:url(#SVGID_00000067224891327043565800000004043511004001501580_);}\r\n\t.st13{clip-path:url(#SVGID_00000003786176474152717940000005099610939395165881_);}\r\n\t.st14{clip-path:url(#SVGID_00000013897273384761600100000001052121261970032776_);}\r\n\t.st15{clip-path:url(#SVGID_00000147192873988242444820000010317642844130502305_);}\r\n\t.st16{clip-path:url(#SVGID_00000032612241766643073800000003849272408499065249_);}\r\n\t.st17{fill:#387FA9;stroke:#051C37;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st18{fill:#051C37;stroke:#051C37;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st19{fill:#051C37;}\r\n\t.st20{fill:#FFFFFF;stroke:#051C37;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st21{clip-path:url(#SVGID_00000122715755882184741580000011303410773759944592_);}\r\n\t.st22{fill:#387FA9;}\r\n\t.st23{fill:none;stroke:#051C37;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st24{clip-path:url(#SVGID_00000174592884910803401380000015062199984763641022_);}\r\n\t.st25{clip-path:url(#SVGID_00000168091098141591460870000005404903111418966916_);}\r\n\t.st26{clip-path:url(#SVGID_00000023274537462274006020000008071437224293115025_);}\r\n\t.st27{clip-path:url(#SVGID_00000160883850999476969720000002838181619210748595_);}\r\n\t.st28{clip-path:url(#SVGID_00000071536212333515256310000003993621057439757981_);}\r\n\t.st29{clip-path:url(#SVGID_00000110458604179584525000000003962851938678661531_);}\r\n\t.st30{clip-path:url(#SVGID_00000087402621924119177570000002877405479135272340_);}\r\n\t.st31{clip-path:url(#SVGID_00000018222588848810485140000017787997470409686168_);}\r\n\t.st32{clip-path:url(#SVGID_00000114768439322624277910000017372143667533123996_);}\r\n\t.st33{clip-path:url(#SVGID_00000127029301220069814930000017470919032675234476_);}\r\n\t.st34{clip-path:url(#SVGID_00000123431392006174884250000015876144867404848573_);}\r\n\t.st35{clip-path:url(#SVGID_00000035488776138648158140000009546971785375606412_);}\r\n\t.st36{clip-path:url(#SVGID_00000084497688689276552760000004100577706933983892_);}\r\n\t.st37{clip-path:url(#SVGID_00000023974449431046072070000013198061444552962441_);}\r\n\t.st38{clip-path:url(#SVGID_00000114059643103952411760000017392699611879871158_);}\r\n\t.st39{clip-path:url(#SVGID_00000102526622557080015400000012647721786837499543_);}\r\n\t.st40{clip-path:url(#SVGID_00000137099291884349001740000017882990954474294673_);}\r\n\t.st41{clip-path:url(#SVGID_00000178189668068350314510000017948475913091503753_);}\r\n\t.st42{clip-path:url(#SVGID_00000042725355147798015450000009033033157651297958_);}\r\n\t.st43{clip-path:url(#SVGID_00000136382612218491531940000009361460175544376227_);}\r\n\t.st44{clip-path:url(#SVGID_00000067952569021715538560000012498052018612809858_);}\r\n\t.st45{clip-path:url(#SVGID_00000073722370763200458510000004065054063842647434_);}\r\n\t.st46{clip-path:url(#SVGID_00000036220474497702665900000000810679850141240746_);}\r\n\t.st47{clip-path:url(#SVGID_00000065769499941145241820000018413342721840060807_);}\r\n\t.st48{clip-path:url(#SVGID_00000087414506081529678740000010454953921604478897_);}\r\n\t.st49{clip-path:url(#SVGID_00000008141511138020476720000017029056804669084045_);}\r\n\t.st50{clip-path:url(#SVGID_00000105391425933490692280000010162698663734699932_);}\r\n\t.st51{clip-path:url(#SVGID_00000181084779988888808590000015091485126852412572_);}\r\n\t.st52{clip-path:url(#SVGID_00000042719359713663249140000013980716088713116850_);}\r\n\t.st53{clip-path:url(#SVGID_00000161600214965782969500000006741786136462559365_);}\r\n\t.st54{clip-path:url(#SVGID_00000084499064124566608870000007454028542764801727_);}\r\n\t.st55{fill:none;stroke:#051C37;stroke-width:0.75;stroke-linecap:round;stroke-linejoin:round;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-1--inject-83"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M441.1,368c-11.4-13-27.4-9.1-16-38.1c7.1-18,12.8-39.1,6-58.1c-8.1-22.7-32.9-34.6-55.6-36.4 c-12.2-1-25.2,4.6-37.1,2.1c-14.4-3-23-17.4-24.6-31.1c0,0,0-0.1,0-0.1h109.4c0,0,1.4-4.1-3.6-6.8s-7.2-0.4-9-2.7s5-8.1-8.5-14 c0,0-0.9-12.6-19.4-13s-13.5,12.6-18.5,15.8s-6.3-1.8-11.2,1.4s-2.7,9.4-6.8,10.4s-9.5-4.1-14.4-0.9s-5,5.9-7.2,5.9s-6.8-1.8-9.5,0 c-0.5,0.4-1.1,0.7-1.6,1.1c-0.8-11.5,1.5-23,3.1-34.5c4.5-33-9.3-58.6-42.2-68.4c-33.9-10-72.3-4.6-102.2,13.7 c-51.1,31.2-19.1,92.2-58.7,109.7s-77.2,53.5-55.6,109c21.3,54.9,66.3,43,66.3,43l1.5,16.9h321.1 C446.7,392.8,452.5,380.9,441.1,368z M212.1,259.3H74c0,0,3.8-2.7,7.1-4.9c3.3-2.2,8.7,0,11.5,0s2.7-3.3,8.7-7.1s12.6,2.2,17.5,1.1 s2.2-8.7,8.2-12.6c6-3.8,7.6,2.2,13.6-1.6s0-19.6,22.4-19.1s23.5,15.8,23.5,15.8c16.4,7.1,8.2,14.2,10.4,16.9s4.9,0,10.9,3.3 S212.1,259.2,212.1,259.3L212.1,259.3z M282.4,127.6h-83.1c0,0,2.3-1.6,4.3-3s5.2,0,6.9,0s1.6-2,5.3-4.3s7.6,1.3,10.5,0.7 s1.3-5.2,4.9-7.6s4.6,1.3,8.2-1s0-11.8,13.5-11.5s14.1,9.5,14.1,9.5c9.9,4.3,4.9,8.5,6.2,10.2s3,0,6.6,2S282.5,127.5,282.4,127.6 L282.4,127.6z M368.8,271h-38c0,0,1-0.8,2-1.4s2.4,0,3.1,0s0.8-0.9,2.4-2s3.5,0.6,4.8,0.3s0.6-2.4,2.2-3.5s2.1,0.6,3.8-0.5 s0-5.4,6.2-5.3s6.5,4.4,6.5,4.4c4.5,2,2.2,3.9,2.9,4.6s1.4,0,3,0.9C368.5,269.1,369,270.1,368.8,271z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3886 -0.9214 0.9214 0.3886 91.864 422.3858)",
    className: "st0",
    cx: 364.2,
    cy: 142,
    rx: 23.2,
    ry: 23.2
  }), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M441.1,368c-11.4-13-27.4-9.1-16-38.1c7.1-18,12.8-39.1,6-58.1c-8.1-22.7-32.9-34.6-55.6-36.4 c-12.2-1-25.2,4.6-37.1,2.1c-14.4-3-23-17.4-24.6-31.1c0,0,0-0.1,0-0.1h109.4c0,0,1.4-4.1-3.6-6.8s-7.2-0.4-9-2.7s5-8.1-8.5-14 c0,0-0.9-12.6-19.4-13s-13.5,12.6-18.5,15.8s-6.3-1.8-11.2,1.4s-2.7,9.4-6.8,10.4s-9.5-4.1-14.4-0.9s-5,5.9-7.2,5.9 s-6.8-1.8-9.5,0c-0.5,0.4-1.1,0.7-1.6,1.1c-0.8-11.5,1.5-23,3.1-34.5c4.5-33-9.3-58.6-42.2-68.4c-33.9-10-72.3-4.6-102.2,13.7 c-51.1,31.2-19.1,92.2-58.7,109.7s-77.2,53.5-55.6,109c21.3,54.9,66.3,43,66.3,43l1.5,16.9h321.1 C446.7,392.8,452.5,380.9,441.1,368z M212.1,259.3H74c0,0,3.8-2.7,7.1-4.9c3.3-2.2,8.7,0,11.5,0s2.7-3.3,8.7-7.1 s12.6,2.2,17.5,1.1s2.2-8.7,8.2-12.6c6-3.8,7.6,2.2,13.6-1.6s0-19.6,22.4-19.1s23.5,15.8,23.5,15.8c16.4,7.1,8.2,14.2,10.4,16.9 s4.9,0,10.9,3.3S212.1,259.2,212.1,259.3L212.1,259.3z M282.4,127.6h-83.1c0,0,2.3-1.6,4.3-3s5.2,0,6.9,0s1.6-2,5.3-4.3 s7.6,1.3,10.5,0.7s1.3-5.2,4.9-7.6s4.6,1.3,8.2-1s0-11.8,13.5-11.5s14.1,9.5,14.1,9.5c9.9,4.3,4.9,8.5,6.2,10.2s3,0,6.6,2 S282.5,127.5,282.4,127.6L282.4,127.6z M368.8,271h-38c0,0,1-0.8,2-1.4s2.4,0,3.1,0s0.8-0.9,2.4-2s3.5,0.6,4.8,0.3 s0.6-2.4,2.2-3.5s2.1,0.6,3.8-0.5s0-5.4,6.2-5.3s6.5,4.4,6.5,4.4c4.5,2,2.2,3.9,2.9,4.6s1.4,0,3,0.9 C368.5,269.1,369,270.1,368.8,271z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3886 -0.9214 0.9214 0.3886 91.864 422.3858)",
    className: "st2",
    cx: 364.2,
    cy: 142,
    rx: 23.2,
    ry: 23.2
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-1--inject-83"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M339,392.6c0,0,8.4-2.8,6-0.6c-0.3,0.3-0.7,0.6-1,0.8h-24.8l-0.8-1.5l-0.2-0.4l-0.3-0.6l3-2l-3.2,1.7l-0.8-1.9 l0.6-6.3l-1,5.7L316,386l-2.8-5.3l4.5,10l-6.4-2.6l6.7,3.1l0.8,1.6h-26.7c-1.5-0.2-3.5-0.6-3.9-1.8c-0.6-1.8,5.7-1.8,5.7-1.8 s-6.6-2.8-4.2-3.4s6.6,1.8,6.6,1.8s-2.4-5.5,0.6-4.3c1.6,0.6,2.8,1.9,3.4,3.5c-0.3-1.1-0.9-3.6,0.7-2.9c1,0.5,1.9,1.3,2.5,2.3 c-0.8-1.6-1.5-4.1,2-3.2c0,0-0.7-7.5,7.2-8.9s7.5,9.5,10.1,11.6s6-0.3,7.2,2.1s0.9,3.7,0.9,3.7s4.5-12,5.1-8.6 c0.3,2.3-0.3,4.5-1.5,6.4c0,0,7.2-9.5,5.7-5.8c-0.9,2.2-2,4.4-3.3,6.4c0,0,9.9-2.5,8.4-0.9S339,392.6,339,392.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M327.1,390.8c0.1-0.5,0.2-1.3,0.4-2.3c0-0.3,0.1-0.5,0.2-0.9c0.5,0.1,1,0.1,1.5,0c0.4-0.1,0.8-0.4,1-0.8 c0.2-0.4,0-0.8-0.4-1c0,0,0,0,0,0c-0.6-0.2-1.5,0.6-1.8,1.1c0,0-0.2,0.4-0.3,0.6c0-0.2,0.1-0.4,0.1-0.5s0.1-0.5,0.2-0.8 s0.1-0.3,0.1-0.4s0.1-0.3,0.1-0.4l0.2-0.6c0.5,0.1,1,0.2,1.5,0.2c0.5,0,0.9-0.3,1.1-0.6c0.2-0.4,0.1-0.8-0.2-1c0,0,0,0-0.1,0 c-0.6-0.2-1.5,0.4-1.9,0.8l-0.2,0.2l0.3-0.6c0.3-0.6,0.6-1.1,0.9-1.7l0.2-0.4c0.5,0.2,1,0.2,1.5,0.2c0.5,0,0.9-0.3,1.2-0.6 c0.2-0.4,0.1-0.8-0.3-1c0,0,0,0-0.1,0c-0.6-0.2-1.5,0.4-1.9,0.8c0,0-0.1,0.1-0.2,0.3c0.2-0.3,0.3-0.6,0.4-0.9 c0.2-0.5,0.5-1.1,0.6-1.7c0.5,0.2,1,0.2,1.5,0.2c0.5,0,0.9-0.3,1.1-0.6c0.2-0.4,0.1-0.8-0.2-1c0,0,0,0-0.1,0 c-0.6-0.2-1.5,0.4-1.9,0.8l-0.4,0.6l0,0c0.1-0.6,0.2-1.1,0.3-1.7c0-0.5,0.1-1,0-1.6c0-0.5,0-0.9-0.1-1.3c0-0.2,0-0.4-0.1-0.6l0,0 c0,0,0.2-0.7,0.2-0.8c0.1-0.6,0-1.7-0.6-2c-0.4-0.2-0.8,0-1,0.4c0,0,0,0,0,0c-0.1,0.4,0,0.9,0.2,1.3c0.3,0.4,0.7,0.7,1.1,1 c0,0.2,0,0.4,0.1,0.6c0,0.4,0,0.8,0,1.3c0,0.1,0,0.3,0,0.4c0-0.2-0.1-0.5-0.1-0.6c-0.2-0.5-0.8-1.5-1.5-1.5c-0.4,0-0.7,0.3-0.7,0.7 c0,0,0,0.1,0,0.1c0.1,0.4,0.4,0.8,0.8,1c0.5,0.2,1,0.3,1.5,0.4c0,0.3,0,0.6-0.1,0.9c-0.1,0.6-0.2,1.1-0.3,1.7v0.1 c0-0.1,0-0.7-0.1-0.8c-0.1-0.5-0.6-1.6-1.3-1.6c-0.4,0-0.8,0.3-0.8,0.7c0,0,0,0.1,0,0.1c0,0.5,0.3,0.9,0.7,1.1 c0.5,0.3,1,0.4,1.5,0.5c-0.2,0.5-0.4,1.1-0.6,1.6c-0.2,0.4-0.4,0.8-0.6,1.1c0-0.1,0-0.7-0.1-0.8c-0.1-0.5-0.6-1.6-1.3-1.6 c-0.4,0-0.8,0.3-0.8,0.7c0,0,0,0.1,0,0.1c0,0.5,0.3,0.9,0.7,1.1c0.5,0.3,0.9,0.5,1.5,0.6c-0.1,0.2-0.2,0.3-0.3,0.5 c-0.3,0.6-0.6,1.1-0.9,1.7c-0.1,0.2-0.2,0.4-0.3,0.6c0-0.2,0-0.6,0-0.7c-0.1-0.5-0.6-1.6-1.3-1.6c-0.4,0-0.8,0.3-0.8,0.7 c0,0,0,0.1,0,0.1c0,0.5,0.3,0.9,0.7,1.1c0.4,0.2,0.9,0.4,1.4,0.5c-0.1,0.3-0.3,0.7-0.4,1c0,0.1-0.1,0.3-0.1,0.4l-0.1,0.4 c-0.1,0.3-0.2,0.5-0.2,0.8s-0.1,0.3-0.1,0.4c0-0.2,0-0.6,0-0.6c0-0.6-0.4-1.6-1-1.8c-0.4-0.1-0.8,0.1-0.9,0.5c0,0,0,0.1,0,0.1 c0,0.5,0.2,0.9,0.5,1.2c0.4,0.3,0.9,0.6,1.4,0.8c-0.1,0.3-0.1,0.6-0.2,0.9c-0.2,0.9-0.3,1.7-0.4,2.3s-0.1,0.9-0.1,0.9l0,0 c0,0.1,0.1,0.2,0.2,0.2c0,0,0,0,0,0c0.1,0,0.2-0.1,0.2-0.2c0,0,0,0,0,0C327,391.7,327,391.4,327.1,390.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M331.6,375.8c0.5,0,1.1,0,1.6-0.2c0.4-0.2,0.8-0.5,0.9-0.9c0.1-0.4-0.1-0.8-0.5-0.9c0,0-0.1,0-0.1,0 c-0.6-0.1-1.4,0.7-1.6,1.2C331.9,375.1,331.6,375.8,331.6,375.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M326.5,390.8c-0.2-0.5-0.6-1.2-1-2.1c-0.1-0.2-0.2-0.5-0.3-0.8c0.5-0.2,0.9-0.5,1.3-0.8 c0.3-0.3,0.5-0.8,0.4-1.2c-0.1-0.4-0.5-0.7-0.9-0.6c0,0-0.1,0-0.1,0c-0.6,0.2-0.9,1.3-0.9,1.9c0,0,0,0.5,0.1,0.7 c-0.1-0.2-0.1-0.3-0.2-0.5s-0.2-0.5-0.3-0.8l-0.1-0.4c0-0.1-0.1-0.3-0.1-0.4s-0.1-0.4-0.1-0.6c0.5-0.1,0.9-0.3,1.3-0.6 c0.4-0.3,0.6-0.7,0.6-1.2c0-0.4-0.4-0.7-0.8-0.7c0,0-0.1,0-0.1,0c-0.6,0.1-1.1,1.1-1.2,1.7c0,0,0,0.1,0,0.3c0-0.2-0.1-0.4-0.1-0.6 c-0.1-0.6-0.1-1.3-0.2-1.9c0-0.1,0-0.3,0-0.4c0.5-0.1,1-0.3,1.4-0.6c0.4-0.3,0.6-0.7,0.6-1.2c0-0.4-0.4-0.7-0.8-0.7 c0,0-0.1,0-0.1,0c-0.6,0.1-1.1,1.1-1.2,1.7c0,0,0,0.2,0,0.3c0-0.4-0.1-0.7-0.1-1c-0.1-0.6-0.2-1.2-0.4-1.7c0.5-0.1,1-0.4,1.4-0.6 c0.4-0.3,0.6-0.7,0.6-1.2c0-0.4-0.4-0.7-0.8-0.7c0,0-0.1,0-0.1,0c-0.6,0.1-1.1,1.1-1.2,1.7c0,0,0,0.6,0,0.7l0,0 c-0.2-0.5-0.4-1.1-0.7-1.6c-0.2-0.5-0.5-0.9-0.8-1.3c-0.3-0.4-0.5-0.7-0.8-1l-0.4-0.5l0,0c0,0-0.2-0.7-0.2-0.8 c-0.2-0.5-1-1.4-1.6-1.3c-0.4,0.1-0.7,0.4-0.6,0.8c0,0,0,0.1,0,0.1c0.1,0.5,0.5,0.8,0.9,1c0.5,0.2,1,0.2,1.5,0.2l0.4,0.5 c0.2,0.3,0.5,0.7,0.8,1.1c0.1,0.1,0.1,0.2,0.2,0.3l-0.4-0.4c-0.4-0.4-1.5-0.8-2-0.4c-0.3,0.2-0.4,0.7-0.2,1c0,0,0,0,0,0.1 c0.3,0.3,0.8,0.5,1.2,0.4c0.5-0.1,1-0.3,1.5-0.5c0.1,0.2,0.3,0.5,0.4,0.8c0.3,0.5,0.5,1,0.6,1.6c0,0,0,0.1,0,0.1 c-0.1-0.1-0.5-0.6-0.5-0.6c-0.4-0.4-1.4-1-2-0.7c-0.4,0.2-0.5,0.7-0.3,1c0,0,0,0,0,0.1c0.3,0.4,0.7,0.6,1.2,0.6 c0.5,0,1-0.2,1.5-0.4c0.2,0.6,0.3,1.1,0.4,1.7c0.1,0.4,0.1,0.8,0.1,1.3l-0.5-0.6c-0.4-0.4-1.4-1-2-0.7c-0.4,0.2-0.5,0.6-0.3,1 c0,0,0,0,0,0.1c0.3,0.4,0.7,0.6,1.2,0.6c0.5,0,1-0.1,1.5-0.3l0.1,0.6c0.1,0.6,0.1,1.3,0.2,1.9l0.1,0.6c-0.1-0.2-0.4-0.5-0.4-0.5 c-0.4-0.4-1.4-0.9-2-0.7c-0.4,0.2-0.5,0.7-0.3,1.1c0,0,0,0,0,0c0.3,0.4,0.7,0.6,1.2,0.6c0.5,0,1-0.1,1.5-0.3c0.1,0.4,0.1,0.7,0.2,1 c0,0.1,0.1,0.3,0.1,0.4l0.1,0.4c0.1,0.3,0.2,0.6,0.3,0.8c0,0.1,0.1,0.2,0.1,0.4c-0.1-0.2-0.3-0.5-0.3-0.5c-0.3-0.5-1.2-1.1-1.8-1 c-0.4,0.1-0.6,0.6-0.4,1c0,0,0,0,0,0c0.2,0.4,0.6,0.7,1.1,0.7c0.5,0,1,0,1.5-0.1c0.1,0.3,0.2,0.6,0.3,0.9c0.4,0.9,0.7,1.6,0.9,2.1 s0.4,0.8,0.4,0.8l0,0c0.1,0.1,0.2,0.1,0.3,0.1c0.1-0.1,0.1-0.2,0.1-0.3C326.7,391.7,326.7,391.3,326.5,390.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M322,375.8c0.5-0.3,0.9-0.6,1.2-1c0.3-0.4,0.4-0.8,0.3-1.3c-0.1-0.4-0.5-0.6-0.9-0.5c0,0,0,0-0.1,0 c-0.6,0.3-0.8,1.4-0.7,2C321.8,375.1,321.9,375.8,322,375.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M440.3,392.5c0,0,10.7-3.5,7.7-0.8c-0.5,0.5-0.9,0.8-1.3,1h-31.6l-1-1.9l-0.2-0.5l-0.4-0.8l3.8-2.6l-4,2.2 l-1.1-2.4l0.8-8l-1.3,7.3l-0.8-2l-3.5-6.8l5.7,12.7l-8.2-3.3l8.6,4l1,2h-34c-1.9-0.2-4.5-0.7-5-2.2c-0.8-2.3,7.2-2.3,7.2-2.3 s-8.4-3.5-5.3-4.3s8.4,2.3,8.4,2.3s-3-7,0.8-5.5c2,0.8,3.6,2.4,4.4,4.5c-0.4-1.4-1.2-4.6,1-3.7c1.3,0.7,2.4,1.7,3.2,3 c-1-2.1-1.9-5.2,2.5-4.1c0,0-0.9-9.6,9.1-11.3s9.5,12.1,13,14.9s7.6-0.4,9.1,2.7s1.1,4.7,1.1,4.7s5.7-15.2,6.5-10.9 s-1.9,8.2-1.9,8.2s9.1-12.1,7.2-7.4c-1.2,2.8-2.6,5.6-4.2,8.2c0,0,12.6-3.1,10.7-1.2S440.3,392.5,440.3,392.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M425.2,390.3c0.1-0.7,0.2-1.7,0.5-2.9c0.1-0.4,0.1-0.7,0.2-1.1c0.7,0.1,1.3,0.1,2,0c0.6-0.1,1.1-0.5,1.3-1 c0.2-0.5-0.1-1.1-0.6-1.3c0,0,0,0,0,0c-0.8-0.2-1.9,0.7-2.3,1.3c0,0-0.3,0.5-0.4,0.8l0.1-0.7c0.1-0.3,0.2-0.7,0.2-1 c0.1-0.2,0.1-0.4,0.2-0.5s0.1-0.4,0.2-0.5s0.2-0.5,0.3-0.8c0.6,0.2,1.2,0.3,1.9,0.3c0.6,0,1.1-0.3,1.5-0.8c0.3-0.5,0.1-1.1-0.4-1.4 c0,0,0,0,0,0c-0.7-0.3-2,0.5-2.5,1l-0.2,0.3c0.1-0.2,0.2-0.5,0.4-0.8c0.3-0.7,0.7-1.5,1.1-2.2c0.1-0.1,0.1-0.3,0.2-0.5 c0.6,0.2,1.3,0.3,1.9,0.3c0.6,0,1.1-0.3,1.5-0.8c0.3-0.5,0.1-1.1-0.4-1.4c0,0,0,0,0,0c-0.7-0.3-2,0.4-2.5,1l-0.2,0.3 c0.2-0.4,0.4-0.8,0.6-1.2c0.3-0.7,0.6-1.4,0.8-2.1c0.6,0.2,1.3,0.3,2,0.3c0.6,0,1.1-0.3,1.5-0.8c0.3-0.5,0.1-1.1-0.4-1.4 c0,0,0,0,0,0c-0.7-0.3-2,0.4-2.5,1l-0.5,0.8l0,0c0.2-0.7,0.3-1.4,0.4-2.2c0.1-0.7,0.1-1.3,0.1-2c0-0.6-0.1-1.2-0.1-1.7 c0-0.3,0-0.5-0.1-0.7l0,0c0,0,0.3-0.9,0.3-1c0.1-0.7,0-2.2-0.8-2.5c-0.5-0.2-1.1,0-1.3,0.5c0,0,0,0,0,0c-0.2,0.6,0,1.2,0.3,1.7 c0.4,0.5,0.9,0.9,1.4,1.3c0,0.2,0,0.5,0.1,0.8c0,0.5,0.1,1.1,0.1,1.7c0,0.2,0,0.3,0,0.5c0-0.3-0.1-0.7-0.1-0.7 c-0.2-0.7-1-1.9-1.8-1.9c-0.6,0-1,0.5-0.9,1.1c0,0,0,0,0,0c0.1,0.6,0.5,1.1,1,1.3c0.6,0.3,1.2,0.4,1.9,0.5c0,0.4,0,0.8-0.1,1.2 c-0.1,0.7-0.2,1.4-0.4,2.1c0,0,0,0.1,0,0.1c0-0.1-0.1-1-0.1-1c-0.1-0.7-0.8-2-1.6-2.1c-0.6,0-1,0.4-1,1c0.1,0.6,0.4,1.1,0.9,1.4 c0.6,0.3,1.2,0.6,1.9,0.7c-0.2,0.7-0.5,1.4-0.8,2c-0.2,0.5-0.5,1-0.7,1.5c0-0.2-0.1-0.9-0.1-1c-0.1-0.7-0.8-2-1.6-2.1 c-0.6,0-1,0.4-1,0.9c0,0,0,0,0,0.1c0.1,0.6,0.4,1.1,0.9,1.4c0.6,0.3,1.2,0.6,1.9,0.7l-0.4,0.7c-0.4,0.7-0.8,1.4-1.1,2.1 c-0.1,0.2-0.2,0.5-0.4,0.8c0-0.3-0.1-0.8-0.1-0.9c-0.1-0.7-0.8-2-1.6-2.1c-0.6,0-1,0.4-1,1c0.1,0.6,0.4,1.1,0.9,1.5 c0.6,0.3,1.2,0.5,1.8,0.7c-0.2,0.4-0.4,0.8-0.5,1.3c-0.1,0.2-0.1,0.4-0.2,0.5s-0.1,0.4-0.2,0.5c-0.1,0.4-0.2,0.7-0.3,1 c0,0.2-0.1,0.3-0.1,0.5c0-0.3,0-0.8,0-0.8c0-0.7-0.5-2.1-1.3-2.3c-0.5-0.1-1.1,0.2-1.2,0.8c0,0,0,0,0,0c0,0.6,0.2,1.2,0.6,1.6 c0.5,0.4,1.1,0.8,1.7,1c-0.1,0.4-0.2,0.8-0.3,1.2c-0.2,1.2-0.4,2.2-0.5,2.9s-0.1,1.1-0.1,1.1l0,0c0,0.2,0.1,0.3,0.3,0.3 c0.2,0,0.3-0.1,0.3-0.2c0,0,0,0,0,0C425.3,391.5,425.1,391,425.2,390.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M431,371.2c0.7,0,1.3,0,2-0.2c0.6-0.2,1-0.6,1.2-1.2c0.1-0.5-0.2-1.1-0.7-1.2c0,0,0,0,0,0 c-0.8-0.1-1.8,1-2.1,1.6C431.3,370.2,431,371.2,431,371.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M424.4,390.3c-0.3-0.6-0.8-1.5-1.2-2.7c-0.1-0.3-0.3-0.7-0.4-1c0.6-0.3,1.2-0.6,1.7-1.1c0.4-0.4,0.6-1,0.5-1.6 c-0.1-0.5-0.7-0.9-1.2-0.7c0,0,0,0,0,0c-0.8,0.3-1.2,1.7-1.1,2.4c0,0,0.1,0.6,0.1,0.9c-0.1-0.2-0.2-0.4-0.3-0.6s-0.2-0.7-0.4-1 s-0.1-0.4-0.2-0.5c-0.1-0.2-0.1-0.4-0.1-0.5c-0.1-0.3-0.1-0.5-0.2-0.8c0.6-0.2,1.2-0.4,1.7-0.8c0.5-0.4,0.8-0.9,0.8-1.5 c0-0.6-0.5-1-1.1-0.9c0,0,0,0,0,0c-0.8,0.1-1.4,1.5-1.5,2.2c0,0,0,0.2,0,0.4c0-0.3-0.1-0.5-0.1-0.8c-0.1-0.8-0.2-1.6-0.3-2.4 l-0.1-0.5c0.6-0.2,1.2-0.4,1.8-0.8c0.5-0.4,0.8-0.9,0.8-1.5c0-0.6-0.5-1-1.1-0.9c0,0,0,0,0,0c-0.8,0.1-1.4,1.5-1.5,2.2 c0,0,0,0.2,0,0.4c-0.1-0.4-0.1-0.9-0.2-1.3c-0.1-0.7-0.3-1.5-0.5-2.2c0.6-0.2,1.3-0.4,1.8-0.8c0.5-0.4,0.8-0.9,0.8-1.5 c0-0.6-0.5-1-1.1-0.9c0,0,0,0,0,0c-0.8,0.1-1.4,1.5-1.5,2.2c0,0,0,0.7,0,1l0,0c-0.2-0.7-0.5-1.4-0.9-2c-0.3-0.6-0.6-1.1-1-1.7 c-0.3-0.5-0.7-1-1-1.3l-0.5-0.6l0,0c0,0-0.3-0.9-0.3-1c-0.3-0.7-1.2-1.8-2-1.7c-0.5,0.1-0.9,0.5-0.8,1c0,0,0,0.1,0,0.1 c0.2,0.6,0.6,1,1.1,1.2c0.6,0.2,1.3,0.3,1.9,0.3c0.1,0.2,0.3,0.4,0.5,0.6c0.3,0.4,0.6,0.8,1,1.4c0.1,0.1,0.2,0.3,0.3,0.4 c-0.2-0.2-0.5-0.5-0.5-0.5c-0.6-0.5-1.9-1-2.6-0.6c-0.4,0.3-0.5,1-0.2,1.4c0,0,0,0,0,0c0.4,0.4,1,0.6,1.6,0.6 c0.6-0.1,1.3-0.3,1.9-0.6c0.2,0.3,0.4,0.6,0.6,1c0.3,0.6,0.6,1.3,0.8,2c0,0,0,0.1,0,0.1c-0.1-0.1-0.6-0.8-0.6-0.8 c-0.5-0.5-1.8-1.2-2.5-0.9c-0.5,0.3-0.6,0.9-0.3,1.4c0,0,0,0,0,0c0.4,0.4,0.9,0.7,1.5,0.7c0.7,0,1.3-0.2,2-0.4 c0.2,0.7,0.3,1.4,0.5,2.1c0.1,0.5,0.1,1.1,0.2,1.6c-0.1-0.2-0.6-0.8-0.6-0.8c-0.5-0.5-1.8-1.2-2.5-0.9c-0.5,0.3-0.6,0.9-0.3,1.4 c0,0,0,0,0,0c0.4,0.5,0.9,0.7,1.5,0.7c0.7,0,1.3-0.2,1.9-0.4c0,0.2,0,0.5,0.1,0.8c0.1,0.8,0.1,1.6,0.2,2.4c0,0.3,0.1,0.5,0.1,0.8 l-0.5-0.7c-0.5-0.5-1.8-1.2-2.5-0.8c-0.5,0.3-0.6,0.9-0.3,1.4c0,0,0,0,0,0c0.4,0.5,0.9,0.7,1.5,0.7c0.6,0,1.3-0.2,1.9-0.4 c0.1,0.5,0.1,0.9,0.2,1.3c0,0.2,0.1,0.4,0.1,0.6l0.2,0.5c0.1,0.4,0.2,0.7,0.4,1c0,0.2,0.1,0.3,0.2,0.5c-0.1-0.3-0.4-0.7-0.4-0.7 c-0.4-0.6-1.6-1.5-2.4-1.2c-0.5,0.2-0.8,0.8-0.5,1.3c0,0,0,0,0,0c0.3,0.5,0.8,0.9,1.4,1c0.7,0.1,1.3,0,2-0.1l0.4,1.1 c0.5,1.1,0.9,2.1,1.2,2.7s0.5,1,0.5,1l0,0c0.1,0.1,0.2,0.2,0.4,0.1c0.1-0.1,0.2-0.2,0.1-0.4C425,391.3,424.7,390.9,424.4,390.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M418.6,371.2c0.6-0.4,1.1-0.8,1.6-1.3c0.4-0.5,0.5-1.1,0.4-1.6c-0.2-0.5-0.8-0.8-1.3-0.6c0,0,0,0,0,0 c-0.7,0.4-1,1.8-0.9,2.5C418.4,370.2,418.6,371.2,418.6,371.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M345.6,392.6c0,0-6.6-2.1-4.7-0.5c0.3,0.3,0.6,0.5,0.8,0.6h19.5l0.6-1.2l0.1-0.3l0.2-0.5l-2.3-1.6l2.5,1.3 l0.6-1.5l-0.5-4.9l0.8,4.5l0.5-1.2l2.2-4.1l-3.5,7.8l5.1-2l-5.3,2.4l-0.6,1.2h21.1c1.1-0.1,2.8-0.5,3.1-1.4 c0.5-1.4-4.5-1.4-4.5-1.4s5.2-2.1,3.3-2.6s-5.2,1.4-5.2,1.4s1.9-4.3-0.5-3.4c-1.2,0.5-2.2,1.5-2.7,2.7c0.2-0.8,0.7-2.8-0.6-2.3 c-0.8,0.4-1.5,1-2,1.8c0.6-1.3,1.2-3.2-1.5-2.5c0.3-3.5-2.2-6.5-5.7-6.9c-6.2-1.1-5.9,7.4-8,9.1s-4.7-0.2-5.6,1.7 c-0.5,0.9-0.8,1.9-0.7,2.9c0,0-3.5-9.3-4-6.7c-0.2,1.8,0.2,3.5,1.2,5c0,0-5.7-7.4-4.5-4.5c0.7,1.7,1.6,3.4,2.6,5 c0,0-7.8-1.9-6.6-0.7S345.6,392.6,345.6,392.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M378.1,391.3c0-0.4-0.1-1-0.3-1.8c0-0.2-0.1-0.4-0.1-0.7c-0.4,0.1-0.8,0.1-1.2,0c-0.4-0.1-0.7-0.3-0.8-0.6 c-0.1-0.3,0-0.6,0.3-0.8c0,0,0.1,0,0.1,0c0.5-0.1,1.2,0.5,1.4,0.8c0.1,0.2,0.2,0.3,0.2,0.5l-0.1-0.4l-0.1-0.6l-0.1-0.3 c0-0.1-0.1-0.2-0.1-0.3s-0.1-0.3-0.2-0.5c-0.4,0.1-0.8,0.2-1.1,0.2c-0.4,0-0.7-0.2-0.9-0.5c-0.2-0.3-0.1-0.6,0.2-0.8c0,0,0,0,0.1,0 c0.5-0.2,1.2,0.3,1.5,0.6l0.1,0.2c-0.1-0.1-0.1-0.3-0.2-0.5c-0.2-0.4-0.4-0.9-0.7-1.3l-0.1-0.3c-0.4,0.1-0.8,0.2-1.2,0.2 c-0.4,0-0.7-0.2-0.9-0.5c-0.1-0.3,0-0.6,0.3-0.8c0.5-0.2,1.2,0.3,1.5,0.6c0,0,0.1,0.1,0.1,0.2c-0.1-0.2-0.2-0.5-0.4-0.7 c-0.2-0.4-0.4-0.9-0.5-1.3c-0.4,0.1-0.8,0.2-1.2,0.2c-0.4,0-0.7-0.2-0.9-0.5c-0.2-0.3-0.1-0.6,0.2-0.8c0,0,0,0,0.1,0 c0.5-0.2,1.2,0.3,1.5,0.6l0.3,0.5l0,0c-0.1-0.4-0.2-0.9-0.2-1.3c0-0.4,0-0.8,0-1.2s0-0.7,0.1-1l0.1-0.5l0,0c0,0-0.2-0.6-0.2-0.6 c-0.1-0.4,0-1.3,0.5-1.5c0.3-0.1,0.6,0,0.8,0.3c0,0,0,0,0,0.1c0.1,0.3,0,0.7-0.2,1c-0.3,0.3-0.6,0.6-0.9,0.8c0,0.1,0,0.3,0,0.5 s0,0.6,0,1v0.3c0-0.2,0.1-0.4,0.1-0.4c0.1-0.4,0.6-1.1,1.1-1.2c0.3,0,0.6,0.3,0.6,0.6c0,0,0,0,0,0.1c-0.1,0.4-0.3,0.7-0.6,0.8 c-0.4,0.2-0.8,0.3-1.2,0.3c0,0.2,0,0.5,0,0.7c0,0.4,0.1,0.9,0.3,1.3c0,0,0,0,0,0.1c0-0.1,0-0.6,0-0.6c0.1-0.4,0.5-1.2,1-1.3 c0.3,0,0.6,0.2,0.6,0.5c0,0,0,0,0,0.1c0,0.4-0.2,0.7-0.5,0.9c-0.4,0.2-0.8,0.4-1.2,0.4c0.1,0.4,0.3,0.8,0.5,1.2 c0.1,0.3,0.3,0.6,0.5,0.9c0-0.1,0-0.6,0-0.6c0.1-0.4,0.5-1.2,1-1.3c0.3,0,0.6,0.2,0.6,0.5c0,0,0,0,0,0.1c0,0.4-0.2,0.7-0.5,0.9 c-0.4,0.2-0.8,0.3-1.2,0.4l0.2,0.4c0.2,0.4,0.5,0.9,0.7,1.3c0.1,0.1,0.1,0.3,0.2,0.5c0-0.2,0-0.5,0-0.5c0.1-0.4,0.5-1.2,1-1.3 c0.3,0,0.6,0.2,0.6,0.5c0,0,0,0,0,0.1c0,0.4-0.2,0.7-0.5,0.9c-0.3,0.2-0.7,0.3-1.1,0.4c0.1,0.2,0.2,0.5,0.3,0.8l0.1,0.3l0.1,0.3 c0.1,0.2,0.1,0.4,0.2,0.6s0,0.2,0.1,0.3c0-0.2,0-0.5,0-0.5c0-0.4,0.3-1.3,0.8-1.4c0.3-0.1,0.6,0.1,0.7,0.4c0,0,0,0,0,0.1 c0,0.4-0.1,0.7-0.4,1c-0.3,0.2-0.7,0.4-1.1,0.6c0.1,0.2,0.1,0.5,0.2,0.7c0.1,0.7,0.2,1.4,0.3,1.8s0.1,0.7,0.1,0.7l0,0 c0,0.1-0.1,0.2-0.2,0.2c-0.1,0-0.2-0.1-0.2-0.1c0,0,0,0,0,0C378.2,392,378.1,391.7,378.1,391.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M374.5,379.6c-0.4,0-0.8,0-1.2-0.1c-0.3-0.1-0.6-0.4-0.7-0.7c-0.1-0.3,0.1-0.6,0.4-0.7c0,0,0,0,0,0 c0.5-0.1,1.1,0.6,1.3,1C374.3,379,374.5,379.6,374.5,379.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M378.6,391.3c0.2-0.4,0.5-1,0.8-1.6c0.1-0.2,0.2-0.4,0.3-0.6c-0.4-0.2-0.7-0.4-1-0.7c-0.3-0.3-0.4-0.6-0.3-1 c0.1-0.3,0.4-0.5,0.7-0.5c0,0,0,0,0.1,0c0.5,0.2,0.7,1,0.7,1.5c0,0,0,0.4-0.1,0.5l0.1-0.4c0.1-0.2,0.2-0.4,0.2-0.6l0.1-0.3 c0-0.1,0.1-0.2,0.1-0.3s0.1-0.3,0.1-0.5c-0.4-0.1-0.7-0.3-1-0.5c-0.3-0.2-0.5-0.6-0.5-0.9c0-0.3,0.3-0.6,0.6-0.6c0,0,0,0,0,0 c0.5,0.1,0.9,0.9,0.9,1.3c0,0,0,0.1,0,0.2c0-0.2,0.1-0.3,0.1-0.5c0.1-0.5,0.1-1,0.2-1.5V384c-0.4-0.1-0.8-0.3-1.1-0.5 c-0.3-0.2-0.5-0.6-0.5-0.9c0-0.3,0.3-0.6,0.6-0.6c0,0,0,0,0.1,0c0.5,0.1,0.9,0.9,0.9,1.3c0,0,0,0.1,0,0.2c0-0.3,0.1-0.5,0.1-0.8 c0.1-0.5,0.2-0.9,0.3-1.3c-0.4-0.1-0.8-0.3-1.1-0.5c-0.3-0.2-0.5-0.5-0.5-0.9c0-0.3,0.3-0.6,0.6-0.6c0,0,0,0,0.1,0 c0.5,0.1,0.9,0.9,0.9,1.3c0,0,0,0.4,0,0.6l0,0c0.1-0.4,0.3-0.8,0.5-1.2c0.2-0.3,0.4-0.7,0.6-1c0.2-0.3,0.4-0.6,0.6-0.8l0.3-0.4l0,0 c0,0,0.2-0.6,0.2-0.6c0.2-0.4,0.8-1.1,1.3-1c0.3,0,0.5,0.3,0.5,0.6c0,0,0,0,0,0.1c-0.1,0.3-0.4,0.6-0.7,0.8 c-0.4,0.1-0.8,0.2-1.2,0.2c-0.1,0.1-0.2,0.2-0.3,0.4c-0.2,0.3-0.4,0.5-0.6,0.8c-0.1,0.1-0.1,0.2-0.2,0.3l0.3-0.3 c0.3-0.3,1.2-0.6,1.6-0.3c0.3,0.2,0.3,0.5,0.2,0.8c0,0,0,0,0,0.1c-0.3,0.3-0.6,0.4-1,0.3c-0.4-0.1-0.8-0.2-1.1-0.4 c-0.1,0.2-0.2,0.4-0.4,0.6c-0.2,0.4-0.4,0.8-0.5,1.2c0,0,0,0,0,0.1l0.4-0.5c0.3-0.3,1.1-0.7,1.5-0.5c0.3,0.1,0.4,0.5,0.2,0.8 c0,0,0,0,0,0.1c-0.2,0.3-0.6,0.4-0.9,0.5c-0.4,0-0.8-0.1-1.2-0.3c-0.1,0.4-0.2,0.9-0.3,1.3c0,0.3-0.1,0.7-0.1,1 c0.1-0.1,0.4-0.5,0.4-0.5c0.3-0.3,1.1-0.7,1.5-0.5c0.3,0.2,0.4,0.5,0.2,0.8c0,0,0,0,0,0.1c-0.2,0.3-0.6,0.4-0.9,0.4 c-0.4,0-0.8-0.1-1.2-0.3c0,0.2,0,0.3,0,0.5c0,0.5-0.1,1-0.1,1.5c0,0.2,0,0.3-0.1,0.5c0.1-0.1,0.3-0.4,0.3-0.4 c0.3-0.3,1.1-0.7,1.5-0.5c0.3,0.1,0.4,0.5,0.3,0.8c0,0,0,0,0,0.1c-0.2,0.3-0.6,0.4-0.9,0.4c-0.4,0-0.8-0.1-1.2-0.2 c0,0.3-0.1,0.5-0.2,0.8c0,0.1,0,0.2-0.1,0.3l-0.1,0.3l-0.2,0.6c0,0.1-0.1,0.2-0.1,0.3c0.1-0.2,0.2-0.4,0.2-0.4 c0.3-0.4,1-0.9,1.5-0.7c0.3,0.1,0.5,0.4,0.4,0.7c0,0,0,0,0,0.1c-0.2,0.3-0.5,0.5-0.9,0.6c-0.4,0-0.8,0-1.2-0.1 c-0.1,0.2-0.2,0.5-0.3,0.7c-0.3,0.7-0.5,1.3-0.7,1.7l-0.3,0.6l0,0c0,0.1-0.1,0.1-0.2,0.1c0,0,0,0,0,0c-0.1,0-0.1-0.1-0.1-0.2 c0,0,0,0,0,0C378.4,391.9,378.4,391.6,378.6,391.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M382.2,379.5c-0.4-0.2-0.7-0.5-1-0.8c-0.2-0.3-0.3-0.7-0.2-1c0.1-0.3,0.4-0.5,0.7-0.4c0,0,0,0,0.1,0 c0.5,0.2,0.6,1.1,0.5,1.5C382.3,379,382.2,379.6,382.2,379.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M355.4,391.5c0-0.3-0.1-0.8-0.2-1.3c0-0.2-0.1-0.3-0.1-0.5c-0.3,0-0.6,0-0.9,0c-0.3-0.1-0.5-0.2-0.6-0.5 c-0.1-0.2,0-0.5,0.2-0.6c0,0,0,0,0.1,0c0.4-0.1,0.9,0.3,1.1,0.6l0.2,0.4c0-0.1,0-0.2-0.1-0.3s-0.1-0.3-0.1-0.5l-0.1-0.2 c0-0.1,0-0.2-0.1-0.2c0-0.1-0.1-0.2-0.1-0.4c-0.3,0.1-0.6,0.1-0.9,0.1c-0.3,0-0.5-0.2-0.7-0.4c-0.1-0.2-0.1-0.5,0.1-0.6 c0,0,0,0,0,0c0.4-0.1,0.9,0.2,1.1,0.5l0.1,0.1c0-0.1-0.1-0.2-0.2-0.4c-0.2-0.3-0.3-0.7-0.5-1l-0.1-0.2c-0.3,0.1-0.6,0.1-0.9,0.1 c-0.3,0-0.5-0.2-0.7-0.4c-0.1-0.2-0.1-0.5,0.2-0.6c0,0,0,0,0,0c0.4-0.1,0.9,0.2,1.1,0.5l0.1,0.1c-0.1-0.2-0.2-0.4-0.3-0.5 c-0.1-0.3-0.3-0.7-0.4-1c-0.3,0.1-0.6,0.1-0.9,0.1c-0.3,0-0.5-0.2-0.7-0.4c-0.1-0.2-0.1-0.5,0.2-0.6c0,0,0,0,0,0 c0.4-0.1,0.9,0.2,1.1,0.5l0.2,0.4l0,0c-0.1-0.3-0.1-0.7-0.2-1c0-0.3,0-0.6,0-0.9c0-0.3,0-0.5,0-0.8s0-0.2,0-0.3l0,0 c-0.1-0.2-0.1-0.3-0.1-0.5c-0.1-0.3,0-1,0.4-1.2c0.2-0.1,0.5,0,0.6,0.2c0,0,0,0,0,0c0.1,0.3,0,0.5-0.1,0.8 c-0.2,0.2-0.4,0.4-0.7,0.6c0,0.1,0,0.2,0,0.4c0,0.3,0,0.5,0,0.8v0.2c0-0.1,0.1-0.3,0.1-0.3c0.1-0.3,0.5-0.9,0.9-0.9 c0.2,0,0.4,0.2,0.4,0.5c0,0,0,0,0,0c-0.1,0.3-0.2,0.5-0.5,0.6c-0.3,0.1-0.6,0.2-0.9,0.2c0,0.2,0,0.4,0,0.5c0,0.3,0.1,0.7,0.2,1 c0,0,0,0,0,0.1c0-0.1,0-0.4,0-0.5c0.1-0.3,0.4-0.9,0.8-1c0.2,0,0.5,0.2,0.5,0.4c0,0,0,0,0,0c0,0.3-0.2,0.5-0.4,0.7 c-0.3,0.1-0.6,0.3-0.9,0.3c0.1,0.3,0.2,0.6,0.4,0.9l0.4,0.7c0-0.1,0-0.4,0-0.5c0.1-0.3,0.4-0.9,0.8-1c0.2,0,0.5,0.2,0.5,0.4 c0,0,0,0,0,0.1c0,0.3-0.2,0.5-0.4,0.7c-0.3,0.2-0.6,0.3-0.9,0.3c0,0.1,0.1,0.2,0.2,0.3c0.2,0.3,0.4,0.7,0.5,1 c0.1,0.1,0.1,0.2,0.2,0.3c0-0.1,0-0.4,0-0.4c0.1-0.3,0.4-0.9,0.8-1c0.2,0,0.5,0.2,0.5,0.4c0,0,0,0,0,0.1c0,0.3-0.2,0.5-0.4,0.7 c-0.3,0.2-0.5,0.3-0.8,0.3c0.1,0.2,0.2,0.4,0.2,0.6c0,0.1,0.1,0.2,0.1,0.2l0.1,0.2c0,0.2,0.1,0.3,0.1,0.5c0,0.1,0,0.2,0,0.2 c0-0.1,0-0.4,0-0.4c0-0.3,0.2-1,0.6-1.1c0.2-0.1,0.5,0.1,0.5,0.3c0,0,0,0,0,0c0,0.3-0.1,0.5-0.3,0.7c-0.2,0.2-0.5,0.3-0.8,0.5 c0,0.2,0.1,0.4,0.1,0.5c0.1,0.5,0.2,1,0.2,1.3s0.1,0.5,0.1,0.5l0,0c0,0.1,0,0.1-0.1,0.1c-0.1,0-0.1,0-0.1-0.1c0,0,0,0,0,0 C355.3,391.9,355.4,391.8,355.4,391.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M352.7,382.7c-0.3,0-0.6,0-0.9-0.1c-0.3-0.1-0.5-0.3-0.6-0.5c-0.1-0.2,0.1-0.5,0.3-0.5c0,0,0,0,0.1,0 c0.4-0.1,0.8,0.4,1,0.7C352.6,382.2,352.7,382.7,352.7,382.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M355.8,391.5c0.1-0.3,0.4-0.7,0.6-1.2c0.1-0.1,0.1-0.3,0.2-0.5c-0.3-0.1-0.5-0.3-0.8-0.5 c-0.2-0.2-0.3-0.5-0.2-0.7c0-0.2,0.3-0.4,0.5-0.4c0,0,0,0,0,0c0.4,0.1,0.5,0.8,0.5,1.1c0,0,0,0.3,0,0.4l0.1-0.3 c0.1-0.1,0.1-0.3,0.2-0.5l0.1-0.2c0-0.1,0.1-0.2,0.1-0.2l0.1-0.4c-0.3-0.1-0.6-0.2-0.8-0.4c-0.2-0.2-0.3-0.4-0.4-0.7 c0-0.2,0.2-0.4,0.5-0.4c0,0,0,0,0.1,0c0.4,0.1,0.6,0.7,0.7,1v0.2c0-0.1,0-0.3,0.1-0.4c0.1-0.4,0.1-0.7,0.1-1.1c0-0.1,0-0.2,0-0.2 c-0.3-0.1-0.6-0.2-0.8-0.4c-0.2-0.2-0.4-0.4-0.4-0.7c0-0.3,0.2-0.4,0.5-0.4c0,0,0,0,0,0c0.4,0.1,0.7,0.7,0.7,1c0,0,0,0.1,0,0.2 c0-0.2,0-0.4,0.1-0.6c0.1-0.3,0.1-0.7,0.2-1c-0.3-0.1-0.6-0.2-0.8-0.4c-0.2-0.2-0.3-0.4-0.4-0.7c0-0.2,0.2-0.4,0.5-0.4c0,0,0,0,0,0 c0.4,0.1,0.6,0.7,0.7,1c0,0,0,0.3,0,0.4l0,0c0.1-0.3,0.2-0.6,0.4-0.9c0.1-0.3,0.3-0.5,0.5-0.8c0.2-0.2,0.3-0.4,0.5-0.6l0.2-0.3l0,0 c0,0,0.1-0.4,0.1-0.5c0.1-0.3,0.6-0.8,1-0.8c0.2,0,0.4,0.3,0.4,0.5c0,0,0,0,0,0c-0.1,0.3-0.3,0.5-0.5,0.6c-0.3,0.1-0.6,0.1-0.9,0.1 l-0.2,0.3c-0.1,0.2-0.3,0.4-0.5,0.6l-0.1,0.2l0.2-0.2c0.3-0.2,0.9-0.5,1.2-0.3c0.2,0.1,0.3,0.4,0.1,0.6c0,0,0,0,0,0 c-0.2,0.2-0.5,0.3-0.7,0.3c-0.3-0.1-0.6-0.2-0.9-0.3c-0.1,0.1-0.2,0.3-0.3,0.5c-0.2,0.3-0.3,0.6-0.4,0.9v0l0.3-0.4 c0.2-0.2,0.8-0.6,1.2-0.4c0.2,0.1,0.3,0.4,0.2,0.6c0,0,0,0,0,0c-0.2,0.2-0.4,0.3-0.7,0.3c-0.3,0-0.6-0.1-0.9-0.2 c-0.1,0.3-0.2,0.7-0.2,1l-0.1,0.8c0.1-0.1,0.2-0.2,0.3-0.4c0.2-0.2,0.8-0.6,1.2-0.4c0.2,0.1,0.3,0.4,0.2,0.6c0,0,0,0,0,0 c-0.2,0.2-0.4,0.3-0.7,0.3c-0.3,0-0.6-0.1-0.9-0.2v0.3c0,0.4-0.1,0.8-0.1,1.1c0,0.1,0,0.2,0,0.4l0.2-0.3c0.2-0.2,0.8-0.6,1.2-0.4 c0.2,0.1,0.3,0.4,0.2,0.6c0,0,0,0,0,0c-0.2,0.2-0.4,0.3-0.7,0.3c-0.3,0-0.6-0.1-0.9-0.2c0,0.2-0.1,0.4-0.1,0.6c0,0.1,0,0.2-0.1,0.2 L357,389l-0.2,0.5c0,0.1-0.1,0.2-0.1,0.2c0.1-0.1,0.2-0.3,0.2-0.3c0.2-0.3,0.7-0.7,1.1-0.6c0.2,0.1,0.4,0.3,0.3,0.6c0,0,0,0,0,0 c-0.1,0.2-0.4,0.4-0.6,0.4c-0.3,0-0.6,0-0.9-0.1l-0.2,0.5c-0.2,0.5-0.4,1-0.5,1.2s-0.2,0.5-0.2,0.5l0,0c0,0.1-0.1,0.1-0.2,0.1 c0-0.1,0-0.1,0-0.2C355.5,391.9,355.6,391.8,355.8,391.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M358.5,382.7c-0.3-0.2-0.5-0.4-0.7-0.6c-0.2-0.2-0.2-0.5-0.2-0.8c0.1-0.2,0.3-0.4,0.6-0.3c0,0,0,0,0,0 c0.3,0.2,0.5,0.8,0.4,1.1C358.6,382.2,358.5,382.7,358.5,382.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--building-2--inject-1--inject-83"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 323.8,
    y: 392.2,
    className: "st4",
    width: 125.9,
    height: 6.8
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 409.6,
    y1: 392.5,
    x2: 409.6,
    y2: 396.4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 412.2,
    y1: 392.5,
    x2: 412.2,
    y2: 394.6
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 414.8,
    y1: 392.5,
    x2: 414.8,
    y2: 394.6
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 417.4,
    y1: 392.5,
    x2: 417.4,
    y2: 398
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 420.5,
    y1: 392.5,
    x2: 420.5,
    y2: 395
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 361,
    y: 299,
    className: "st6",
    width: 29.1,
    height: 14
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 380,
    y: 299,
    className: "st4",
    width: 10.1,
    height: 14
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "349.9,320 349.9,291.8 262.6,291.8 262.6,399 320,399 349.9,399 407.3,399 407.3,320  "
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 395.7,
    y: 320,
    className: "st4",
    width: 11.6,
    height: 79
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 349.7,
    y: 314,
    className: "st6",
    width: 57.5,
    height: 16.3
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 292.4,
    y: 292.6,
    className: "st6",
    width: 57.5,
    height: 16.3
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 252.6,
    y: 288.7,
    className: "st4",
    width: 100.9,
    height: 16.3
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 349.7,
    y: 310.2,
    className: "st4",
    width: 62.8,
    height: 16.3
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 325.4,
    y1: 289,
    x2: 325.4,
    y2: 295.4
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 328,
    y1: 289,
    x2: 328,
    y2: 295.4
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 328,
    y1: 297.1,
    x2: 328,
    y2: 302.1
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 330.6,
    y1: 289,
    x2: 330.6,
    y2: 295.4
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 330.6,
    y1: 297.4,
    x2: 330.6,
    y2: 302
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 333.1,
    y1: 297.4,
    x2: 333.1,
    y2: 300.3
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 333.2,
    y1: 289,
    x2: 333.2,
    y2: 295.4
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 336.2,
    y1: 293.8,
    x2: 336.2,
    y2: 295.4
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 336.4,
    y1: 289,
    x2: 336.4,
    y2: 292.6
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 325.4,
    y1: 296.7,
    x2: 325.4,
    y2: 300.5
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 352.4,
    y1: 310.3,
    x2: 352.4,
    y2: 316.8
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 355,
    y1: 310.3,
    x2: 355,
    y2: 316.8
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 355,
    y1: 318.5,
    x2: 355,
    y2: 323.4
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 357.6,
    y1: 310.3,
    x2: 357.6,
    y2: 316.8
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 357.6,
    y1: 318.8,
    x2: 357.6,
    y2: 323.4
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 360,
    y1: 318.8,
    x2: 360,
    y2: 321.7
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 360.2,
    y1: 310.3,
    x2: 360.2,
    y2: 316.8
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 363.1,
    y1: 315.1,
    x2: 363.1,
    y2: 316.8
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 363.3,
    y1: 310.3,
    x2: 363.3,
    y2: 314
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 352.4,
    y1: 318.1,
    x2: 352.4,
    y2: 321.9
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 326.6,
    y: 339.9,
    className: "st2",
    width: 19.2,
    height: 17.5
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 326.6,
    y: 339.9,
    width: 19.2,
    height: 17.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000090977116445554439350000014466281569206315701_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000090977116445554439350000014466281569206315701_)"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "326.6,353.3 326.6,356.8 345.9,341.1 345.9,339.9 343.1,339.9  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "345.9,348.4 345.9,344.9 330.5,357.4 334.8,357.4  "
  }))))), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 326.6,
    y: 339.9,
    className: "st11",
    width: 19.2,
    height: 17.5
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 326.6,
    y: 334.9,
    className: "st4",
    width: 19.2,
    height: 7.6
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 353.8,
    y: 339.9,
    className: "st2",
    width: 19.2,
    height: 17.5
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000083790269341005215280000002557004039049834155_",
    x: 353.8,
    y: 339.9,
    width: 19.2,
    height: 17.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000027583660673077573500000002942566817177442467_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000083790269341005215280000002557004039049834155_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000027583660673077573500000002942566817177442467_)"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "370.2,339.9 353.8,353.3 353.8,356.8 373.1,341.1 373.1,339.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "361.9,357.4 373.1,348.4 373.1,344.9 357.7,357.4  "
  }))))), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 353.8,
    y: 339.9,
    className: "st11",
    width: 19.2,
    height: 17.5
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 353.8,
    y: 334.9,
    className: "st4",
    width: 19.2,
    height: 7.6
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 381,
    y: 339.9,
    className: "st2",
    width: 19.2,
    height: 17.5
  })), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000070101216234243151710000003509538459513973394_",
    x: 381,
    y: 339.9,
    width: 19.2,
    height: 17.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000093150132015187704370000002039375559117938837_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000070101216234243151710000003509538459513973394_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000093150132015187704370000002039375559117938837_)"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "397.4,339.9 381,353.3 381,356.8 400.2,341.1 400.2,339.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "389.1,357.4 400.2,348.4 400.2,344.9 384.8,357.4  "
  }))))), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 381,
    y: 339.9,
    className: "st11",
    width: 19.2,
    height: 17.5
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 381,
    y: 334.9,
    className: "st4",
    width: 19.2,
    height: 7.6
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 326.6,
    y: 369.4,
    className: "st2",
    width: 19.2,
    height: 17.5
  })), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000018927661613793747240000011531042444358649472_",
    x: 326.6,
    y: 369.4,
    width: 19.2,
    height: 17.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000111179696229793209860000001991841518504058266_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000018927661613793747240000011531042444358649472_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000111179696229793209860000001991841518504058266_)"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "326.6,382.7 326.6,386.2 345.9,370.6 345.9,369.4 343.1,369.4  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "345.9,377.8 345.9,374.4 330.5,386.9 334.8,386.9  "
  }))))), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 326.6,
    y: 369.4,
    className: "st11",
    width: 19.2,
    height: 17.5
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 326.6,
    y: 364.4,
    className: "st4",
    width: 19.2,
    height: 7.6
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 353.8,
    y: 369.4,
    className: "st2",
    width: 19.2,
    height: 17.5
  })), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000013172380236888835290000000199962851216120976_",
    x: 353.8,
    y: 369.4,
    width: 19.2,
    height: 17.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000059299488903309507890000013890842227070873751_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000013172380236888835290000000199962851216120976_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000059299488903309507890000013890842227070873751_)"
    }
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "353.8,382.7 353.8,386.2 373.1,370.6 373.1,369.4 370.2,369.4  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "357.7,386.9 361.9,386.9 373.1,377.8 373.1,374.4  "
  }))))), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 353.8,
    y: 369.4,
    className: "st11",
    width: 19.2,
    height: 17.5
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 353.8,
    y: 364.4,
    className: "st4",
    width: 19.2,
    height: 7.6
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 381,
    y: 369.4,
    className: "st2",
    width: 19.2,
    height: 17.5
  })), /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000036252892987739783630000013756628884124574888_",
    x: 381,
    y: 369.4,
    width: 19.2,
    height: 17.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000140734735820382440710000008254693787770901640_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000036252892987739783630000013756628884124574888_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000140734735820382440710000008254693787770901640_)"
    }
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "397.4,369.4 381,382.7 381,386.2 400.2,370.6 400.2,369.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "389.1,386.9 400.2,377.8 400.2,374.4 384.8,386.9  "
  }))))), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 381,
    y: 369.4,
    className: "st11",
    width: 19.2,
    height: 17.5
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 381,
    y: 364.4,
    className: "st4",
    width: 19.2,
    height: 7.6
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--building-1--inject-1--inject-83"
  }, _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 95.3,
    y: 282.1,
    className: "st17",
    width: 22.6,
    height: 20
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 105.6,
    y: 282.1,
    className: "st18",
    width: 22.6,
    height: 20
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 96.5,
    y: 309,
    className: "st18",
    width: 89,
    height: 90.1
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 90.8,
    y: 299.1,
    className: "st19",
    width: 94.7,
    height: 16.3
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 133.2,
    y: 265.4,
    className: "st19",
    width: 27.5,
    height: 25.7
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "147,250.9 130.3,266 163.6,266  "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "163.6,266 147,250.9 137.9,266  "
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 134.1,
    y: 287.1,
    className: "st19",
    width: 1.9,
    height: 15.5
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 157.3,
    y: 287.1,
    className: "st19",
    width: 1.9,
    height: 15.5
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 144.6,
    y: 287.1,
    className: "st19",
    width: 1.9,
    height: 15.5
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 148.2,
    y: 287.1,
    className: "st19",
    width: 1.9,
    height: 15.5
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 99.8,
    y: 320,
    className: "st20",
    width: 4.7,
    height: 18.8
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 99.8,
    y: 349.8,
    className: "st20",
    width: 4.7,
    height: 18.8
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 171.1,
    y: 143.5,
    className: "st18",
    width: 151.7,
    height: 255.6
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 235.4,
    y: 143.5,
    className: "st20",
    width: 87.3,
    height: 255.6
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 245.6,
    y: 143.5,
    className: "st17",
    width: 67,
    height: 255.6
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 235.4,
    y: 143.5,
    className: "st18",
    width: 87.3,
    height: 17.5
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 257.9,
    y: 367.6,
    className: "st2",
    width: 42.4,
    height: 31.4
  })), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000029024434223647478780000013266614973824033179_",
    x: 257.9,
    y: 367.6,
    width: 42.4,
    height: 31.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000139288164882200597790000012165198527757505665_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000029024434223647478780000013266614973824033179_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139288164882200597790000012165198527757505665_)"
    }
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "276.5,377.8 258.3,394.4 258.3,398.9 258.6,398.9 279.1,380.2 279.1,377.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "269.6,398.9 279.1,390.2 279.1,385.4 264.4,398.9  "
  }))))), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 257.9,
    y: 367.6,
    className: "st23",
    width: 42.4,
    height: 31.4
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 279.1,
    y: 367.6,
    className: "st2",
    width: 21.2,
    height: 31.4
  })), /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000125562379323977703530000017089150524629969818_",
    x: 279.1,
    y: 367.6,
    width: 21.2,
    height: 31.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000000916863803629115240000010732345980092540597_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000125562379323977703530000017089150524629969818_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000000916863803629115240000010732345980092540597_)"
    }
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "297.3,377.8 279.1,394.4 279.1,398.9 279.4,398.9 300,380.2 300,377.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "290.4,398.9 300,390.2 300,385.4 285.2,398.9  "
  }))))), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 279.1,
    y: 367.6,
    className: "st23",
    width: 21.2,
    height: 31.4
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 181.2,
    y: 172.1,
    className: "st2",
    width: 19.2,
    height: 17.5
  })), /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000052091712686530413730000014963913907904701824_",
    x: 181.2,
    y: 172.1,
    width: 19.2,
    height: 17.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000096764750435314036970000011282996658815528879_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000052091712686530413730000014963913907904701824_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000096764750435314036970000011282996658815528879_)"
    }
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st22",
    points: "200.4,173.3 200.4,172.1 197.6,172.1 181.2,185.5 181.2,188.9  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st22",
    points: "200.4,180.6 200.4,177.1 185,189.6 189.3,189.6  "
  }))))), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 181.2,
    y: 172.1,
    className: "st23",
    width: 19.2,
    height: 17.5
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 181.2,
    y: 167.1,
    className: "st20",
    width: 19.2,
    height: 7.6
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 208.7,
    y: 172.1,
    className: "st2",
    width: 19.2,
    height: 17.5
  })), /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000070825845903688234430000018036445984532608172_",
    x: 208.7,
    y: 172.1,
    width: 19.2,
    height: 17.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000039127422542280316680000014248858787161704111_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000070825845903688234430000018036445984532608172_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000039127422542280316680000014248858787161704111_)"
    }
  }, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st22",
    points: "208.7,185.5 208.7,188.9 228,173.3 228,172.1 225.1,172.1  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st22",
    points: "228,180.6 228,177.1 212.6,189.6 216.8,189.6  "
  }))))), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 208.7,
    y: 172.1,
    className: "st23",
    width: 19.2,
    height: 17.5
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 208.7,
    y: 167.1,
    className: "st20",
    width: 19.2,
    height: 7.6
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 181.2,
    y: 205.7,
    className: "st2",
    width: 19.2,
    height: 17.5
  })), /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000112598211400180722990000002486969909914614445_",
    x: 181.2,
    y: 205.7,
    width: 19.2,
    height: 17.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000030453072255102523340000007087039798838258562_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000112598211400180722990000002486969909914614445_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000030453072255102523340000007087039798838258562_)"
    }
  }, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st22",
    points: "181.2,219 181.2,222.5 200.4,206.9 200.4,205.7 197.6,205.7  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st22",
    points: "200.4,214.1 200.4,210.7 185,223.2 189.3,223.2  "
  }))))), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 181.2,
    y: 205.7,
    className: "st23",
    width: 19.2,
    height: 17.5
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 181.2,
    y: 200.7,
    className: "st20",
    width: 19.2,
    height: 7.6
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 208.7,
    y: 205.7,
    className: "st2",
    width: 19.2,
    height: 17.5
  })), /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000119822177731717119610000006106553857483405758_",
    x: 208.7,
    y: 205.7,
    width: 19.2,
    height: 17.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000090999120636014492670000002720746330638910378_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000119822177731717119610000006106553857483405758_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000090999120636014492670000002720746330638910378_)"
    }
  }, _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st22",
    points: "228,206.9 228,205.7 225.1,205.7 208.7,219 208.7,222.5  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st22",
    points: "212.6,223.2 216.8,223.2 228,214.1 228,210.7  "
  }))))), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 208.7,
    y: 205.7,
    className: "st23",
    width: 19.2,
    height: 17.5
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 208.7,
    y: 200.7,
    className: "st20",
    width: 19.2,
    height: 7.6
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 181.2,
    y: 239.3,
    className: "st2",
    width: 19.2,
    height: 17.5
  })), /*#__PURE__*/React.createElement("g", null, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000082349784271807972930000002639948242888183186_",
    x: 181.2,
    y: 239.3,
    width: 19.2,
    height: 17.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000016779543307248701630000007532689613550131373_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000082349784271807972930000002639948242888183186_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000016779543307248701630000007532689613550131373_)"
    }
  }, _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st22",
    points: "181.2,252.6 181.2,256.1 200.4,240.4 200.4,239.3 197.6,239.3  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st22",
    points: "200.4,247.7 200.4,244.2 185,256.7 189.3,256.7  "
  }))))), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 181.2,
    y: 239.3,
    className: "st23",
    width: 19.2,
    height: 17.5
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 181.2,
    y: 234.2,
    className: "st20",
    width: 19.2,
    height: 7.6
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 208.7,
    y: 239.3,
    className: "st2",
    width: 19.2,
    height: 17.5
  })), /*#__PURE__*/React.createElement("g", null, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000058559778588595809160000012689418630089786286_",
    x: 208.7,
    y: 239.3,
    width: 19.2,
    height: 17.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000132048264395088031660000000571114482282166186_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000058559778588595809160000012689418630089786286_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000132048264395088031660000000571114482282166186_)"
    }
  }, _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st22",
    points: "208.7,252.6 208.7,256.1 228,240.4 228,239.3 225.1,239.3  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st22",
    points: "212.6,256.7 216.8,256.7 228,247.7 228,244.2  "
  }))))), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 208.7,
    y: 239.3,
    className: "st23",
    width: 19.2,
    height: 17.5
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 208.7,
    y: 234.2,
    className: "st20",
    width: 19.2,
    height: 7.6
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 181.2,
    y: 272.8,
    className: "st2",
    width: 19.2,
    height: 17.5
  })), /*#__PURE__*/React.createElement("g", null, _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000009556368424321786890000006767154187399665799_",
    x: 181.2,
    y: 272.8,
    width: 19.2,
    height: 17.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000137123867650745006090000002154648034944532146_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000009556368424321786890000006767154187399665799_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000137123867650745006090000002154648034944532146_)"
    }
  }, _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "197.6,272.8 181.2,286.2 181.2,289.6 200.4,274 200.4,272.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "189.3,290.3 200.4,281.3 200.4,277.8 185,290.3  "
  }))))), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 181.2,
    y: 272.8,
    className: "st23",
    width: 19.2,
    height: 17.5
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 181.2,
    y: 267.8,
    className: "st20",
    width: 19.2,
    height: 7.6
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 208.7,
    y: 272.8,
    className: "st2",
    width: 19.2,
    height: 17.5
  })), /*#__PURE__*/React.createElement("g", null, _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000061443107962013403540000004602203687364585627_",
    x: 208.7,
    y: 272.8,
    width: 19.2,
    height: 17.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000098201467717535201810000015628611412294314390_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000061443107962013403540000004602203687364585627_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000098201467717535201810000015628611412294314390_)"
    }
  }, _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st22",
    points: "208.7,286.2 208.7,289.6 228,274 228,272.8 225.1,272.8  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st22",
    points: "212.6,290.3 216.8,290.3 228,281.3 228,277.8  "
  }))))), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 208.7,
    y: 272.8,
    className: "st23",
    width: 19.2,
    height: 17.5
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 208.7,
    y: 267.8,
    className: "st20",
    width: 19.2,
    height: 7.6
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 181.2,
    y: 306.4,
    className: "st2",
    width: 19.2,
    height: 17.5
  })), /*#__PURE__*/React.createElement("g", null, _defs17 || (_defs17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000150076469673176164760000004553846441348553356_",
    x: 181.2,
    y: 306.4,
    width: 19.2,
    height: 17.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000040559849491600802900000015256744661779170971_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000150076469673176164760000004553846441348553356_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000040559849491600802900000015256744661779170971_)"
    }
  }, _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "197.6,306.4 181.2,319.7 181.2,323.2 200.4,307.5 200.4,306.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "189.3,323.9 200.4,314.8 200.4,311.4 185,323.9  "
  }))))), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 181.2,
    y: 306.4,
    className: "st23",
    width: 19.2,
    height: 17.5
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 181.2,
    y: 301.4,
    className: "st20",
    width: 19.2,
    height: 7.6
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 208.7,
    y: 306.4,
    className: "st2",
    width: 19.2,
    height: 17.5
  })), /*#__PURE__*/React.createElement("g", null, _defs18 || (_defs18 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000078012406549195027450000003264298741528688828_",
    x: 208.7,
    y: 306.4,
    width: 19.2,
    height: 17.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000010281031387937254430000017717075049981598138_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000078012406549195027450000003264298741528688828_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000010281031387937254430000017717075049981598138_)"
    }
  }, _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "225.1,306.4 208.7,319.7 208.7,323.2 228,307.5 228,306.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "216.8,323.9 228,314.8 228,311.4 212.6,323.9  "
  }))))), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 208.7,
    y: 306.4,
    className: "st23",
    width: 19.2,
    height: 17.5
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 208.7,
    y: 301.4,
    className: "st20",
    width: 19.2,
    height: 7.6
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 181.2,
    y: 339.9,
    className: "st2",
    width: 19.2,
    height: 17.5
  })), /*#__PURE__*/React.createElement("g", null, _defs19 || (_defs19 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000080922489209732117160000007217861993848617349_",
    x: 181.2,
    y: 339.9,
    width: 19.2,
    height: 17.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000096741964236233080610000010592028950531679675_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000080922489209732117160000007217861993848617349_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000096741964236233080610000010592028950531679675_)"
    }
  }, _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "197.6,339.9 181.2,353.3 181.2,356.8 200.4,341.1 200.4,339.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "189.3,357.4 200.4,348.4 200.4,344.9 185,357.4  "
  }))))), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 181.2,
    y: 339.9,
    className: "st23",
    width: 19.2,
    height: 17.5
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 181.2,
    y: 334.9,
    className: "st20",
    width: 19.2,
    height: 7.6
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 208.7,
    y: 339.9,
    className: "st2",
    width: 19.2,
    height: 17.5
  })), /*#__PURE__*/React.createElement("g", null, _defs20 || (_defs20 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000116929396077360489560000009451676715898050233_",
    x: 208.7,
    y: 339.9,
    width: 19.2,
    height: 17.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000103251471940863803330000018131143213249220007_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000116929396077360489560000009451676715898050233_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000103251471940863803330000018131143213249220007_)"
    }
  }, _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "225.1,339.9 208.7,353.3 208.7,356.8 228,341.1 228,339.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "216.8,357.4 228,348.4 228,344.9 212.6,357.4  "
  }))))), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 208.7,
    y: 339.9,
    className: "st23",
    width: 19.2,
    height: 17.5
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 208.7,
    y: 334.9,
    className: "st20",
    width: 19.2,
    height: 7.6
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 242.5,
    y: 172.1,
    className: "st2",
    width: 19.2,
    height: 17.5
  })), /*#__PURE__*/React.createElement("g", null, _defs21 || (_defs21 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000071526679323184083490000002468267887458781842_",
    x: 242.5,
    y: 172.1,
    width: 19.2,
    height: 17.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000137096274773265032420000016150306628214631848_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000071526679323184083490000002468267887458781842_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000137096274773265032420000016150306628214631848_)"
    }
  }, _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st22",
    points: "242.5,185.5 242.5,188.9 261.7,173.3 261.7,172.1 258.9,172.1  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st22",
    points: "261.7,180.6 261.7,177.1 246.4,189.6 250.6,189.6  "
  }))))), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 242.5,
    y: 172.1,
    className: "st23",
    width: 19.2,
    height: 17.5
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 242.5,
    y: 167.1,
    className: "st20",
    width: 19.2,
    height: 7.6
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 172.1,
    className: "st2",
    width: 19.2,
    height: 17.5
  })), /*#__PURE__*/React.createElement("g", null, _defs22 || (_defs22 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000119814855634160241520000011528928701116969619_",
    x: 270,
    y: 172.1,
    width: 19.2,
    height: 17.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000034079977978809228730000004883449717242222742_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000119814855634160241520000011528928701116969619_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000034079977978809228730000004883449717242222742_)"
    }
  }, _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st22",
    points: "289.3,173.3 289.3,172.1 286.4,172.1 270,185.5 270,188.9  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st22",
    points: "289.3,180.6 289.3,177.1 273.9,189.6 278.1,189.6  "
  }))))), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 172.1,
    className: "st23",
    width: 19.2,
    height: 17.5
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 167.1,
    className: "st20",
    width: 19.2,
    height: 7.6
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 297.5,
    y: 172.1,
    className: "st2",
    width: 19.2,
    height: 17.5
  })), /*#__PURE__*/React.createElement("g", null, _defs23 || (_defs23 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000014615900431638570790000007940531710079384713_",
    x: 297.5,
    y: 172.1,
    width: 19.2,
    height: 17.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000027574506739494470920000016060109362673570944_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000014615900431638570790000007940531710079384713_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000027574506739494470920000016060109362673570944_)"
    }
  }, _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st22",
    points: "297.5,185.5 297.5,188.9 316.8,173.3 316.8,172.1 314,172.1  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st22",
    points: "301.4,189.6 305.6,189.6 316.8,180.6 316.8,177.1  "
  }))))), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: 297.5,
    y: 172.1,
    className: "st23",
    width: 19.2,
    height: 17.5
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 297.5,
    y: 167.1,
    className: "st20",
    width: 19.2,
    height: 7.6
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    x: 242.5,
    y: 205.7,
    className: "st2",
    width: 19.2,
    height: 17.5
  })), /*#__PURE__*/React.createElement("g", null, _defs24 || (_defs24 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000110464778173137666200000000954403888034502535_",
    x: 242.5,
    y: 205.7,
    width: 19.2,
    height: 17.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000091704374614575305650000005866738968792546698_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000110464778173137666200000000954403888034502535_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000091704374614575305650000005866738968792546698_)"
    }
  }, _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st22",
    points: "242.5,219 242.5,222.5 261.7,206.9 261.7,205.7 258.9,205.7  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st22",
    points: "246.4,223.2 250.6,223.2 261.7,214.1 261.7,210.7  "
  }))))), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    x: 242.5,
    y: 205.7,
    className: "st23",
    width: 19.2,
    height: 17.5
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    x: 242.5,
    y: 200.7,
    className: "st20",
    width: 19.2,
    height: 7.6
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 205.7,
    className: "st2",
    width: 19.2,
    height: 17.5
  })), /*#__PURE__*/React.createElement("g", null, _defs25 || (_defs25 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000066509979117792245510000012228781655746564757_",
    x: 270,
    y: 205.7,
    width: 19.2,
    height: 17.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000165941105107123422250000011680466111639408831_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000066509979117792245510000012228781655746564757_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000165941105107123422250000011680466111639408831_)"
    }
  }, _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st22",
    points: "270,219 270,222.5 289.3,206.9 289.3,205.7 286.4,205.7  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st22",
    points: "273.9,223.2 278.1,223.2 289.3,214.1 289.3,210.7  "
  }))))), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 205.7,
    className: "st23",
    width: 19.2,
    height: 17.5
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 200.7,
    className: "st20",
    width: 19.2,
    height: 7.6
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    x: 297.5,
    y: 205.7,
    className: "st2",
    width: 19.2,
    height: 17.5
  })), /*#__PURE__*/React.createElement("g", null, _defs26 || (_defs26 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000150794893788032028140000016710925689188792972_",
    x: 297.5,
    y: 205.7,
    width: 19.2,
    height: 17.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000000916561516655199980000012582950532373066424_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000150794893788032028140000016710925689188792972_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000000916561516655199980000012582950532373066424_)"
    }
  }, _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st22",
    points: "297.5,219 297.5,222.5 316.8,206.9 316.8,205.7 314,205.7  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st22",
    points: "316.8,214.1 316.8,210.7 301.4,223.2 305.6,223.2  "
  }))))), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    x: 297.5,
    y: 205.7,
    className: "st23",
    width: 19.2,
    height: 17.5
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    x: 297.5,
    y: 200.7,
    className: "st20",
    width: 19.2,
    height: 7.6
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    x: 242.5,
    y: 239.3,
    className: "st2",
    width: 19.2,
    height: 17.5
  })), /*#__PURE__*/React.createElement("g", null, _defs27 || (_defs27 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000143586760797084417200000009013969911036413608_",
    x: 242.5,
    y: 239.3,
    width: 19.2,
    height: 17.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000165954479411784414780000006385173105213163710_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000143586760797084417200000009013969911036413608_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000165954479411784414780000006385173105213163710_)"
    }
  }, _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st22",
    points: "242.5,252.6 242.5,256.1 261.7,240.4 261.7,239.3 258.9,239.3  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st22",
    points: "261.7,247.7 261.7,244.2 246.4,256.7 250.6,256.7  "
  }))))), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    x: 242.5,
    y: 239.3,
    className: "st23",
    width: 19.2,
    height: 17.5
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    x: 242.5,
    y: 234.2,
    className: "st20",
    width: 19.2,
    height: 7.6
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 239.3,
    className: "st2",
    width: 19.2,
    height: 17.5
  })), /*#__PURE__*/React.createElement("g", null, _defs28 || (_defs28 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000034778006536764504140000014154767545377294491_",
    x: 270,
    y: 239.3,
    width: 19.2,
    height: 17.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000137820115497170115310000010295447367853150624_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000034778006536764504140000014154767545377294491_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000137820115497170115310000010295447367853150624_)"
    }
  }, _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st22",
    points: "270,252.6 270,256.1 289.3,240.4 289.3,239.3 286.4,239.3  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st22",
    points: "289.3,247.7 289.3,244.2 273.9,256.7 278.1,256.7  "
  }))))), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 239.3,
    className: "st23",
    width: 19.2,
    height: 17.5
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 234.2,
    className: "st20",
    width: 19.2,
    height: 7.6
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    x: 297.5,
    y: 239.3,
    className: "st2",
    width: 19.2,
    height: 17.5
  })), /*#__PURE__*/React.createElement("g", null, _defs29 || (_defs29 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000110446404882679378490000010059294303880096129_",
    x: 297.5,
    y: 239.3,
    width: 19.2,
    height: 17.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000029016359330399667330000007518904007326541718_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000110446404882679378490000010059294303880096129_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000029016359330399667330000007518904007326541718_)"
    }
  }, _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st22",
    points: "297.5,252.6 297.5,256.1 316.8,240.4 316.8,239.3 314,239.3  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st22",
    points: "301.4,256.7 305.6,256.7 316.8,247.7 316.8,244.2  "
  }))))), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    x: 297.5,
    y: 239.3,
    className: "st23",
    width: 19.2,
    height: 17.5
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    x: 297.5,
    y: 234.2,
    className: "st20",
    width: 19.2,
    height: 7.6
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    x: 242.5,
    y: 272.8,
    className: "st2",
    width: 19.2,
    height: 17.5
  })), /*#__PURE__*/React.createElement("g", null, _defs30 || (_defs30 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000108272464998117264540000002950010299736005022_",
    x: 242.5,
    y: 272.8,
    width: 19.2,
    height: 17.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000029732724724688485440000007318570499901873286_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000108272464998117264540000002950010299736005022_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000029732724724688485440000007318570499901873286_)"
    }
  }, _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "258.9,272.8 242.5,286.2 242.5,289.6 261.7,274 261.7,272.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "250.6,290.3 261.7,281.3 261.7,277.8 246.4,290.3  "
  }))))), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    x: 242.5,
    y: 272.8,
    className: "st23",
    width: 19.2,
    height: 17.5
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    x: 242.5,
    y: 267.8,
    className: "st20",
    width: 19.2,
    height: 7.6
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 272.8,
    className: "st2",
    width: 19.2,
    height: 17.5
  })), /*#__PURE__*/React.createElement("g", null, _defs31 || (_defs31 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000136385989486354802700000016926530918744429444_",
    x: 270,
    y: 272.8,
    width: 19.2,
    height: 17.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000088840490459076688900000014144538499848334014_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000136385989486354802700000016926530918744429444_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000088840490459076688900000014144538499848334014_)"
    }
  }, _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st22",
    points: "270,286.2 270,289.6 289.3,274 289.3,272.8 286.4,272.8  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st22",
    points: "289.3,281.3 289.3,277.8 273.9,290.3 278.1,290.3  "
  }))))), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 272.8,
    className: "st23",
    width: 19.2,
    height: 17.5
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 267.8,
    className: "st20",
    width: 19.2,
    height: 7.6
  })), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    x: 297.5,
    y: 272.8,
    className: "st2",
    width: 19.2,
    height: 17.5
  })), /*#__PURE__*/React.createElement("g", null, _defs32 || (_defs32 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000163769259512994944820000014395711818010532761_",
    x: 297.5,
    y: 272.8,
    width: 19.2,
    height: 17.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000158017851224145139270000006741532154976599470_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000163769259512994944820000014395711818010532761_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000158017851224145139270000006741532154976599470_)"
    }
  }, _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st22",
    points: "297.5,286.2 297.5,289.6 316.8,274 316.8,272.8 314,272.8  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st22",
    points: "301.4,290.3 305.6,290.3 316.8,281.3 316.8,277.8  "
  }))))), _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    x: 297.5,
    y: 272.8,
    className: "st23",
    width: 19.2,
    height: 17.5
  })), _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    x: 297.5,
    y: 267.8,
    className: "st20",
    width: 19.2,
    height: 7.6
  })), _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    x: 242.5,
    y: 306.4,
    className: "st2",
    width: 19.2,
    height: 17.5
  })), /*#__PURE__*/React.createElement("g", null, _defs33 || (_defs33 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000068659454434057239030000008627910289150901376_",
    x: 242.5,
    y: 306.4,
    width: 19.2,
    height: 17.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000074439072309698760460000004346661957286481058_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000068659454434057239030000008627910289150901376_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000074439072309698760460000004346661957286481058_)"
    }
  }, _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "258.9,306.4 242.5,319.7 242.5,323.2 261.7,307.5 261.7,306.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "250.6,323.9 261.7,314.8 261.7,311.4 246.4,323.9  "
  }))))), _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    x: 242.5,
    y: 306.4,
    className: "st23",
    width: 19.2,
    height: 17.5
  })), _rect120 || (_rect120 = /*#__PURE__*/React.createElement("rect", {
    x: 242.5,
    y: 301.4,
    className: "st20",
    width: 19.2,
    height: 7.6
  })), _rect121 || (_rect121 = /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 306.4,
    className: "st2",
    width: 19.2,
    height: 17.5
  })), /*#__PURE__*/React.createElement("g", null, _defs34 || (_defs34 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000098213909319539226080000000909549211653262241_",
    x: 270,
    y: 306.4,
    width: 19.2,
    height: 17.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000183207330336130259530000001480166528736754595_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000098213909319539226080000000909549211653262241_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000183207330336130259530000001480166528736754595_)"
    }
  }, _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "286.4,306.4 270,319.7 270,323.2 289.3,307.5 289.3,306.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "278.1,323.9 289.3,314.8 289.3,311.4 273.9,323.9  "
  }))))), _rect122 || (_rect122 = /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 306.4,
    className: "st23",
    width: 19.2,
    height: 17.5
  })), _rect123 || (_rect123 = /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 301.4,
    className: "st20",
    width: 19.2,
    height: 7.6
  })), _rect124 || (_rect124 = /*#__PURE__*/React.createElement("rect", {
    x: 297.5,
    y: 306.4,
    className: "st2",
    width: 19.2,
    height: 17.5
  })), /*#__PURE__*/React.createElement("g", null, _defs35 || (_defs35 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000046298122151210929230000016521792231964368775_",
    x: 297.5,
    y: 306.4,
    width: 19.2,
    height: 17.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000152958344932576579200000000171707773361684881_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000046298122151210929230000016521792231964368775_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000152958344932576579200000000171707773361684881_)"
    }
  }, _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st22",
    points: "316.8,307.5 316.8,306.4 314,306.4 297.5,319.7 297.5,323.2  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st22",
    points: "301.4,323.9 305.6,323.9 316.8,314.8 316.8,311.4  "
  }))))), _rect125 || (_rect125 = /*#__PURE__*/React.createElement("rect", {
    x: 297.5,
    y: 306.4,
    className: "st23",
    width: 19.2,
    height: 17.5
  })), _rect126 || (_rect126 = /*#__PURE__*/React.createElement("rect", {
    x: 297.5,
    y: 301.4,
    className: "st20",
    width: 19.2,
    height: 7.6
  })), _rect127 || (_rect127 = /*#__PURE__*/React.createElement("rect", {
    x: 242.5,
    y: 339.9,
    className: "st2",
    width: 19.2,
    height: 17.5
  })), /*#__PURE__*/React.createElement("g", null, _defs36 || (_defs36 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000107576908665166279160000008931093957703449514_",
    x: 242.5,
    y: 339.9,
    width: 19.2,
    height: 17.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000052802104050506081730000011506963501346106771_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000107576908665166279160000008931093957703449514_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000052802104050506081730000011506963501346106771_)"
    }
  }, _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "258.9,339.9 242.5,353.3 242.5,356.8 261.7,341.1 261.7,339.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "250.6,357.4 261.7,348.4 261.7,344.9 246.4,357.4  "
  }))))), _rect128 || (_rect128 = /*#__PURE__*/React.createElement("rect", {
    x: 242.5,
    y: 339.9,
    className: "st23",
    width: 19.2,
    height: 17.5
  })), _rect129 || (_rect129 = /*#__PURE__*/React.createElement("rect", {
    x: 242.5,
    y: 334.9,
    className: "st20",
    width: 19.2,
    height: 7.6
  })), _rect130 || (_rect130 = /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 339.9,
    className: "st2",
    width: 19.2,
    height: 17.5
  })), /*#__PURE__*/React.createElement("g", null, _defs37 || (_defs37 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000059282884550918138630000004613742351727346619_",
    x: 270,
    y: 339.9,
    width: 19.2,
    height: 17.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000134965268039689566630000009245301154225921463_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000059282884550918138630000004613742351727346619_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000134965268039689566630000009245301154225921463_)"
    }
  }, _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "286.4,339.9 270,353.3 270,356.8 289.3,341.1 289.3,339.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "278.1,357.4 289.3,348.4 289.3,344.9 273.9,357.4  "
  }))))), _rect131 || (_rect131 = /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 339.9,
    className: "st23",
    width: 19.2,
    height: 17.5
  })), _rect132 || (_rect132 = /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 334.9,
    className: "st20",
    width: 19.2,
    height: 7.6
  })), _rect133 || (_rect133 = /*#__PURE__*/React.createElement("rect", {
    x: 297.5,
    y: 339.9,
    className: "st2",
    width: 19.2,
    height: 17.5
  })), /*#__PURE__*/React.createElement("g", null, _defs38 || (_defs38 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000177474197139886532500000017605158803985502646_",
    x: 297.5,
    y: 339.9,
    width: 19.2,
    height: 17.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000139973576633123607100000013229329387245240451_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000177474197139886532500000017605158803985502646_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139973576633123607100000013229329387245240451_)"
    }
  }, _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "314,339.9 297.5,353.3 297.5,356.8 316.8,341.1 316.8,339.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "305.6,357.4 316.8,348.4 316.8,344.9 301.4,357.4  "
  }))))), _rect134 || (_rect134 = /*#__PURE__*/React.createElement("rect", {
    x: 297.5,
    y: 339.9,
    className: "st23",
    width: 19.2,
    height: 17.5
  })), _rect135 || (_rect135 = /*#__PURE__*/React.createElement("rect", {
    x: 297.5,
    y: 334.9,
    className: "st20",
    width: 19.2,
    height: 7.6
  })), _rect136 || (_rect136 = /*#__PURE__*/React.createElement("rect", {
    x: 241.6,
    y: 367.6,
    className: "st18",
    width: 75,
    height: 9.5
  })), _rect137 || (_rect137 = /*#__PURE__*/React.createElement("rect", {
    x: 241.6,
    y: 364.8,
    className: "st20",
    width: 75,
    height: 9.5
  })), _rect138 || (_rect138 = /*#__PURE__*/React.createElement("rect", {
    x: 171,
    y: 130.3,
    className: "st18",
    width: 40.9,
    height: 25.2
  })), _rect139 || (_rect139 = /*#__PURE__*/React.createElement("rect", {
    x: 197.8,
    y: 130.3,
    className: "st20",
    width: 14.1,
    height: 25.2
  })), _rect140 || (_rect140 = /*#__PURE__*/React.createElement("rect", {
    x: 298.6,
    y: 136.5,
    className: "st18",
    width: 16.8,
    height: 19
  })), _rect141 || (_rect141 = /*#__PURE__*/React.createElement("rect", {
    x: 167.4,
    y: 143.5,
    className: "st18",
    width: 159,
    height: 12
  })), _rect142 || (_rect142 = /*#__PURE__*/React.createElement("rect", {
    x: 231.4,
    y: 143.5,
    className: "st20",
    width: 95.1,
    height: 12
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    className: "st55",
    x1: 235.4,
    y1: 143.5,
    x2: 235.4,
    y2: 148.5
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    className: "st55",
    x1: 238,
    y1: 143.5,
    x2: 238,
    y2: 148.5
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    className: "st55",
    x1: 238,
    y1: 149.9,
    x2: 238,
    y2: 153.7
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    className: "st55",
    x1: 240.6,
    y1: 143.5,
    x2: 240.6,
    y2: 148.5
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    className: "st55",
    x1: 240.6,
    y1: 150.1,
    x2: 240.6,
    y2: 153.7
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    className: "st55",
    x1: 243.1,
    y1: 150.1,
    x2: 243.1,
    y2: 152.4
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    className: "st55",
    x1: 243.2,
    y1: 143.5,
    x2: 243.2,
    y2: 148.5
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    className: "st55",
    x1: 246.2,
    y1: 147.2,
    x2: 246.2,
    y2: 148.5
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    className: "st55",
    x1: 246.4,
    y1: 143.5,
    x2: 246.4,
    y2: 146.3
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    className: "st55",
    x1: 235.4,
    y1: 149.5,
    x2: 235.4,
    y2: 152.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M131.4,392.6c0,0,8.4-2.8,6-0.6c-0.3,0.3-0.7,0.6-1,0.8h-24.7l-0.8-1.5l-0.2-0.4l-0.3-0.6l3-2l-3.2,1.7 l-0.8-1.9l0.6-6.3l-1,5.7l-0.6-1.5l-2.8-5.3l4.5,10l-6.4-2.6l6.7,3.1l0.8,1.6H84.6c-1.5-0.2-3.5-0.6-3.9-1.8 c-0.6-1.8,5.7-1.8,5.7-1.8s-6.6-2.8-4.2-3.4s6.6,1.8,6.6,1.8s-2.4-5.5,0.6-4.3c1.6,0.6,2.8,1.9,3.4,3.5c-0.3-1.1-0.9-3.6,0.7-2.9 c1,0.5,1.9,1.3,2.5,2.3c-0.8-1.6-1.5-4.1,2-3.2c0,0-0.7-7.5,7.2-8.9s7.5,9.5,10.2,11.6s6-0.3,7.2,2.1s0.9,3.7,0.9,3.7 s4.5-12,5.1-8.6c0.3,2.3-0.3,4.5-1.5,6.4c0,0,7.2-9.5,5.7-5.8c-0.9,2.2-2,4.4-3.3,6.4c0,0,9.9-2.5,8.4-0.9S131.4,392.6,131.4,392.6 z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M119.6,390.8c0.1-0.5,0.2-1.3,0.3-2.3c0.1-0.3,0.1-0.5,0.2-0.9c0.5,0.1,1,0.1,1.6,0c0.4-0.1,0.8-0.4,1-0.8 c0.2-0.4,0-0.8-0.4-1c0,0,0,0,0,0c-0.6-0.2-1.5,0.6-1.8,1.1c0,0-0.2,0.4-0.3,0.6c0-0.2,0.1-0.4,0.1-0.5s0.1-0.5,0.2-0.8 s0.1-0.3,0.1-0.4s0.1-0.3,0.1-0.4l0.2-0.6c0.5,0.1,1,0.2,1.5,0.2c0.5,0,0.9-0.3,1.2-0.6c0.2-0.4,0.1-0.8-0.2-1c0,0,0,0-0.1,0 c-0.6-0.2-1.6,0.4-1.9,0.8l-0.2,0.2l0.3-0.6c0.3-0.6,0.6-1.1,0.9-1.7l0.2-0.4c0.5,0.2,1,0.2,1.5,0.2c0.5,0,0.9-0.3,1.2-0.6 c0.2-0.4,0.1-0.8-0.3-1c0,0,0,0-0.1,0c-0.6-0.2-1.6,0.4-1.9,0.8c0,0-0.1,0.1-0.2,0.3c0.2-0.3,0.3-0.6,0.4-0.9 c0.2-0.5,0.5-1.1,0.6-1.7c0.5,0.2,1,0.2,1.5,0.2c0.5,0,0.9-0.3,1.2-0.6c0.2-0.4,0.1-0.8-0.2-1c0,0,0,0-0.1,0 c-0.6-0.2-1.6,0.4-1.9,0.8l-0.4,0.6l0,0c0.1-0.6,0.2-1.1,0.3-1.7c0-0.5,0.1-1,0.1-1.6c0-0.5-0.1-0.9-0.1-1.3c0-0.2,0-0.4-0.1-0.6 l0,0c0,0,0.2-0.7,0.2-0.8c0.1-0.6,0-1.7-0.6-2c-0.4-0.2-0.8,0-1,0.4c0,0,0,0,0,0c-0.1,0.4,0,0.9,0.2,1.3c0.3,0.4,0.7,0.7,1.1,1 c0,0.2,0,0.4,0.1,0.6c0,0.4,0,0.8,0,1.3c0,0.1,0,0.3,0,0.4c0-0.2-0.1-0.5-0.1-0.6c-0.2-0.5-0.8-1.5-1.4-1.5c-0.4,0-0.7,0.3-0.7,0.7 c0,0,0,0.1,0,0.1c0.1,0.4,0.4,0.8,0.8,1c0.5,0.2,1,0.3,1.5,0.4c0,0.3,0,0.6-0.1,0.9c-0.1,0.6-0.2,1.1-0.3,1.7v0.1 c0-0.1,0-0.7-0.1-0.8c-0.1-0.5-0.7-1.6-1.3-1.6c-0.4,0-0.8,0.3-0.8,0.7c0,0,0,0.1,0,0.1c0,0.5,0.3,0.9,0.7,1.1 c0.5,0.3,1,0.4,1.5,0.5c-0.2,0.5-0.4,1.1-0.6,1.6c-0.2,0.4-0.4,0.8-0.6,1.1c0-0.1,0-0.7-0.1-0.8c-0.1-0.5-0.7-1.6-1.3-1.6 c-0.4,0-0.8,0.3-0.8,0.7c0,0,0,0.1,0,0.1c0,0.5,0.3,0.9,0.7,1.1c0.5,0.3,0.9,0.5,1.5,0.6c-0.1,0.2-0.2,0.3-0.3,0.5 c-0.3,0.6-0.6,1.1-0.9,1.7c-0.1,0.2-0.2,0.4-0.3,0.6c0-0.2,0-0.6,0-0.7c-0.1-0.5-0.7-1.6-1.3-1.6c-0.4,0-0.8,0.3-0.8,0.7 c0,0,0,0.1,0,0.1c0,0.5,0.3,0.9,0.7,1.1c0.4,0.2,0.9,0.4,1.4,0.5c-0.2,0.3-0.3,0.7-0.4,1c0,0.1-0.1,0.3-0.2,0.4l-0.1,0.4 c-0.1,0.3-0.2,0.5-0.2,0.8s-0.1,0.3-0.1,0.4c0-0.2,0-0.6,0-0.6c0-0.6-0.4-1.6-1-1.8c-0.4-0.1-0.8,0.1-0.9,0.5c0,0,0,0.1,0,0.1 c0,0.5,0.2,0.9,0.5,1.2c0.4,0.3,0.9,0.6,1.3,0.8c-0.1,0.3-0.2,0.6-0.2,0.9c-0.2,0.9-0.3,1.7-0.4,2.3s-0.1,0.9-0.1,0.9l0,0 c0,0.1,0.1,0.2,0.2,0.2c0,0,0,0,0,0c0.1,0,0.2-0.1,0.2-0.2c0,0,0,0,0,0C119.5,391.7,119.5,391.4,119.6,390.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M124.1,375.8c0.5,0,1.1,0,1.6-0.2c0.4-0.2,0.8-0.5,0.9-0.9c0.1-0.4-0.1-0.8-0.5-0.9c0,0-0.1,0-0.1,0 c-0.6-0.1-1.4,0.7-1.7,1.2C124.4,375.1,124.1,375.8,124.1,375.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M119,390.8c-0.2-0.5-0.6-1.2-1-2.1c-0.1-0.2-0.2-0.5-0.3-0.8c0.5-0.2,0.9-0.5,1.3-0.8 c0.3-0.3,0.5-0.8,0.4-1.2c-0.1-0.4-0.5-0.7-0.9-0.6c0,0-0.1,0-0.1,0c-0.6,0.2-0.9,1.3-0.9,1.9c0,0,0,0.5,0.1,0.7 c-0.1-0.2-0.1-0.3-0.2-0.5s-0.2-0.5-0.3-0.8l-0.1-0.4c-0.1-0.1-0.1-0.3-0.1-0.4s-0.1-0.4-0.1-0.6c0.5-0.1,0.9-0.3,1.3-0.6 c0.4-0.3,0.6-0.7,0.6-1.2c0-0.4-0.4-0.7-0.8-0.7c0,0-0.1,0-0.1,0c-0.6,0.1-1.1,1.1-1.2,1.7c0,0,0,0.1,0,0.3c0-0.2-0.1-0.4-0.1-0.6 c-0.1-0.6-0.2-1.3-0.2-1.9c0-0.1,0-0.3,0-0.4c0.5-0.1,1-0.3,1.4-0.6c0.4-0.3,0.6-0.7,0.6-1.2c0-0.4-0.4-0.7-0.8-0.7 c0,0-0.1,0-0.1,0c-0.6,0.1-1.1,1.1-1.2,1.7c0,0,0,0.2,0,0.3c0-0.4-0.1-0.7-0.2-1c-0.1-0.6-0.2-1.2-0.4-1.7c0.5-0.1,1-0.4,1.4-0.6 c0.4-0.3,0.6-0.7,0.6-1.2c0-0.4-0.4-0.7-0.8-0.7c0,0-0.1,0-0.1,0c-0.6,0.1-1.1,1.1-1.2,1.7c0,0,0,0.6,0,0.7l0,0 c-0.2-0.5-0.4-1.1-0.7-1.6c-0.2-0.5-0.5-0.9-0.8-1.3c-0.3-0.4-0.6-0.7-0.8-1l-0.4-0.5l0,0c0,0-0.2-0.7-0.2-0.8 c-0.2-0.5-1-1.4-1.6-1.3c-0.4,0.1-0.7,0.4-0.6,0.8c0,0,0,0.1,0,0.1c0.1,0.5,0.5,0.8,0.9,1c0.5,0.2,1,0.2,1.5,0.2l0.4,0.5 c0.2,0.3,0.5,0.7,0.8,1.1c0.1,0.1,0.1,0.2,0.2,0.3l-0.4-0.4c-0.4-0.4-1.5-0.8-2-0.4c-0.3,0.2-0.4,0.7-0.2,1c0,0,0,0,0,0.1 c0.3,0.3,0.8,0.5,1.2,0.4c0.5-0.1,1-0.3,1.4-0.5c0.2,0.2,0.3,0.5,0.4,0.8c0.3,0.5,0.5,1,0.7,1.6c0,0,0,0.1,0,0.1 c-0.1-0.1-0.4-0.6-0.5-0.6c-0.4-0.4-1.4-1-2-0.7c-0.4,0.2-0.5,0.7-0.3,1c0,0,0,0,0,0.1c0.3,0.4,0.7,0.6,1.2,0.6 c0.5,0,1-0.2,1.5-0.4c0.2,0.6,0.3,1.1,0.3,1.7c0.1,0.4,0.1,0.8,0.2,1.3l-0.5-0.6c-0.4-0.4-1.4-1-2-0.7c-0.4,0.2-0.5,0.6-0.3,1 c0,0,0,0,0,0.1c0.3,0.4,0.7,0.6,1.2,0.6c0.5,0,1-0.1,1.5-0.3l0.1,0.6c0.1,0.6,0.1,1.3,0.2,1.9l0.1,0.6c-0.1-0.2-0.4-0.5-0.4-0.5 c-0.4-0.4-1.4-0.9-2-0.7c-0.4,0.2-0.5,0.7-0.3,1.1c0,0,0,0,0,0c0.3,0.4,0.7,0.6,1.2,0.6c0.5,0,1-0.1,1.5-0.3c0.1,0.4,0.1,0.7,0.2,1 c0,0.1,0.1,0.3,0.1,0.4l0.1,0.4l0.3,0.8c0.1,0.1,0.1,0.2,0.1,0.4c-0.1-0.2-0.3-0.5-0.3-0.5c-0.3-0.5-1.2-1.1-1.8-1 c-0.4,0.1-0.6,0.6-0.4,1c0,0,0,0,0,0c0.2,0.4,0.6,0.7,1.1,0.7c0.5,0,1,0,1.6-0.1c0.1,0.3,0.2,0.6,0.3,0.9c0.4,0.9,0.7,1.6,0.9,2.1 s0.4,0.8,0.4,0.8l0,0c0.1,0.1,0.2,0.1,0.3,0.1s0.1-0.2,0.1-0.3l0,0C119.3,391.7,119.2,391.3,119,390.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M114.4,375.8c0.5-0.3,0.9-0.6,1.2-1c0.3-0.4,0.4-0.8,0.3-1.3c-0.1-0.4-0.5-0.6-0.9-0.5c0,0,0,0-0.1,0 c-0.6,0.3-0.8,1.4-0.7,2C114.3,375.1,114.4,375.8,114.4,375.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M232.8,392.5c0,0,10.7-3.5,7.6-0.8c-0.4,0.4-0.8,0.7-1.3,1h-31.5l-0.9-1.9l-0.2-0.5l-0.4-0.8l3.8-2.6l-4,2.2 l-1.1-2.4l0.8-8l-1.3,7.3l-0.8-2l-3.6-6.7l5.7,12.7l-8.2-3.3l8.6,4l1,2H173c-1.9-0.2-4.5-0.7-4.9-2.2c-0.8-2.3,7.2-2.3,7.2-2.3 s-8.4-3.5-5.3-4.3s8.4,2.3,8.4,2.3s-3-7,0.8-5.5c2,0.8,3.6,2.4,4.4,4.5c-0.4-1.4-1.2-4.6,0.9-3.7c1.3,0.7,2.4,1.7,3.2,3 c-1-2.1-1.9-5.2,2.5-4.1c0,0-0.9-9.6,9.1-11.3s9.5,12.1,13,14.9s7.6-0.4,9.1,2.7s1.1,4.7,1.1,4.7s5.7-15.2,6.5-10.9 s-1.9,8.2-1.9,8.2s9.1-12.1,7.2-7.4c-1.2,2.8-2.6,5.6-4.2,8.2c0,0,12.6-3.1,10.7-1.2S232.8,392.5,232.8,392.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M217.7,390.3c0.1-0.7,0.2-1.7,0.4-2.9c0.1-0.4,0.1-0.7,0.2-1.1c0.7,0.1,1.3,0.1,2,0c0.6-0.1,1.1-0.5,1.3-1 c0.2-0.5-0.1-1.1-0.6-1.3c0,0,0,0,0,0c-0.8-0.2-1.9,0.7-2.3,1.3c0,0-0.3,0.5-0.4,0.8c0.1-0.2,0.1-0.5,0.1-0.7s0.2-0.7,0.2-1 c0.1-0.2,0.1-0.4,0.2-0.5s0.1-0.4,0.2-0.5s0.2-0.5,0.3-0.8c0.6,0.2,1.2,0.3,1.9,0.3c0.6,0,1.1-0.3,1.5-0.8c0.3-0.5,0.1-1.1-0.4-1.4 c0,0,0,0,0,0c-0.7-0.3-2,0.5-2.5,1l-0.2,0.3c0.1-0.2,0.2-0.5,0.4-0.8c0.3-0.7,0.7-1.5,1.1-2.2l0.2-0.5c0.6,0.2,1.3,0.3,1.9,0.3 c0.6,0,1.1-0.3,1.5-0.8c0.3-0.5,0.1-1.1-0.4-1.4c0,0,0,0,0,0c-0.7-0.3-2,0.4-2.5,1l-0.2,0.3c0.2-0.4,0.4-0.8,0.6-1.2 c0.3-0.7,0.6-1.4,0.8-2.1c0.6,0.2,1.3,0.3,2,0.3c0.6,0,1.1-0.3,1.5-0.8c0.3-0.5,0.1-1.1-0.4-1.4c0,0,0,0,0,0c-0.7-0.3-2,0.4-2.4,1 l-0.5,0.8l0,0c0.2-0.7,0.3-1.4,0.4-2.2c0.1-0.7,0.1-1.3,0.1-2c0-0.6,0-1.1-0.1-1.7c0-0.3,0-0.5-0.1-0.7l0,0c0,0,0.3-0.9,0.3-1 c0.1-0.7-0.1-2.2-0.8-2.5c-0.5-0.2-1.1,0-1.3,0.5c0,0,0,0,0,0c-0.2,0.6-0.1,1.2,0.3,1.7c0.4,0.5,0.9,0.9,1.4,1.3 c0,0.2,0.1,0.5,0.1,0.8c0,0.5,0.1,1.1,0.1,1.7c0,0.2,0,0.3,0,0.5c0-0.3-0.1-0.7-0.1-0.7c-0.2-0.7-1-1.9-1.8-1.9 c-0.6,0-1,0.5-0.9,1.1c0,0,0,0,0,0c0.1,0.6,0.5,1.1,1,1.3c0.6,0.3,1.2,0.4,1.9,0.5c0,0.4,0,0.8-0.1,1.2c-0.1,0.7-0.2,1.4-0.4,2.1 v0.1c0-0.1-0.1-1-0.1-1c-0.1-0.7-0.8-2-1.6-2.1c-0.6,0-1,0.4-1,1c0.1,0.6,0.4,1.1,0.9,1.4c0.6,0.3,1.2,0.6,1.9,0.7 c-0.2,0.7-0.5,1.4-0.8,2c-0.2,0.5-0.5,1-0.7,1.5c0-0.2-0.1-0.9-0.1-1c-0.1-0.7-0.8-2-1.6-2.1c-0.6,0-1,0.4-1,1 c0.1,0.6,0.4,1.1,0.9,1.4c0.6,0.3,1.2,0.6,1.9,0.7L221,379c-0.4,0.7-0.8,1.4-1.1,2.1c-0.1,0.3-0.2,0.5-0.4,0.8 c0-0.3-0.1-0.8-0.1-0.9c-0.1-0.7-0.8-2-1.6-2.1c-0.6,0-1,0.4-1,1c0.1,0.6,0.4,1.1,0.9,1.5c0.6,0.3,1.2,0.5,1.8,0.7 c-0.2,0.4-0.4,0.8-0.5,1.3c-0.1,0.2-0.1,0.4-0.2,0.5s-0.1,0.4-0.2,0.5c-0.1,0.4-0.2,0.7-0.3,1c0,0.2-0.1,0.3-0.1,0.5 c0-0.3,0.1-0.8,0.1-0.8c0-0.7-0.5-2.1-1.3-2.3c-0.5-0.1-1.1,0.2-1.2,0.8c0,0,0,0,0,0c0,0.6,0.2,1.2,0.6,1.6c0.5,0.4,1.1,0.8,1.7,1 c-0.1,0.4-0.2,0.8-0.3,1.2c-0.2,1.2-0.4,2.2-0.5,2.9s-0.1,1.1-0.1,1.1l0,0c0,0.2,0.1,0.3,0.3,0.3c0.2,0,0.3-0.1,0.3-0.2 c0,0,0,0,0,0C217.8,391.5,217.6,391,217.7,390.3z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M223.5,371.2c0.7,0,1.3,0,2-0.2c0.6-0.2,1-0.6,1.2-1.2c0.1-0.5-0.2-1.1-0.7-1.2c0,0,0,0,0,0 c-0.8-0.1-1.8,1-2.1,1.6C223.8,370.2,223.5,371.2,223.5,371.2z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M216.9,390.3c-0.3-0.6-0.8-1.5-1.2-2.7c-0.1-0.3-0.3-0.7-0.4-1c0.6-0.3,1.2-0.6,1.7-1.1 c0.4-0.4,0.6-1,0.5-1.6c-0.1-0.5-0.7-0.9-1.2-0.7c0,0,0,0,0,0c-0.8,0.3-1.2,1.7-1.1,2.4c0,0,0.1,0.6,0.1,0.9 c-0.1-0.2-0.2-0.4-0.3-0.6s-0.2-0.7-0.4-1s-0.1-0.4-0.2-0.5s-0.1-0.4-0.1-0.5s-0.1-0.5-0.2-0.8c0.6-0.2,1.2-0.4,1.7-0.8 c0.5-0.4,0.8-0.9,0.8-1.5c0-0.6-0.5-1-1.1-0.9c0,0,0,0,0,0c-0.8,0.1-1.4,1.5-1.5,2.2c0,0,0,0.2,0,0.4c-0.1-0.3-0.1-0.5-0.1-0.8 c-0.1-0.8-0.2-1.6-0.3-2.4l-0.1-0.5c0.6-0.2,1.2-0.4,1.8-0.8c0.5-0.4,0.8-0.9,0.8-1.5c0-0.6-0.5-1-1.1-0.9c0,0,0,0,0,0 c-0.8,0.1-1.4,1.5-1.5,2.2c0,0,0,0.2,0,0.4c-0.1-0.4-0.1-0.9-0.2-1.3c-0.1-0.7-0.3-1.5-0.5-2.2c0.6-0.2,1.3-0.4,1.8-0.8 c0.5-0.4,0.8-0.9,0.8-1.5c0-0.6-0.5-1-1.1-0.9c0,0,0,0,0,0c-0.8,0.1-1.4,1.5-1.5,2.2c0,0,0,0.7,0,1l0,0c-0.2-0.7-0.5-1.4-0.9-2 c-0.3-0.6-0.6-1.1-1-1.7c-0.3-0.5-0.7-1-1-1.3l-0.5-0.6l0,0c0,0-0.3-0.9-0.3-1c-0.3-0.7-1.2-1.8-2-1.7c-0.5,0.1-0.9,0.5-0.8,1 c0,0,0,0.1,0,0.1c0.2,0.6,0.6,1,1.1,1.2c0.6,0.2,1.3,0.3,1.9,0.3c0.1,0.2,0.3,0.4,0.5,0.6c0.3,0.4,0.6,0.8,1,1.4 c0.1,0.1,0.2,0.3,0.3,0.4c-0.2-0.2-0.5-0.5-0.5-0.5c-0.6-0.5-1.9-1-2.6-0.6c-0.4,0.3-0.5,1-0.2,1.4c0,0,0,0,0,0 c0.4,0.4,1,0.6,1.6,0.6c0.6-0.1,1.3-0.3,1.9-0.6c0.2,0.3,0.4,0.6,0.6,1c0.3,0.6,0.6,1.3,0.8,2c0,0,0,0.1,0,0.1 c-0.1-0.1-0.6-0.8-0.6-0.8c-0.5-0.5-1.8-1.2-2.5-0.9c-0.5,0.3-0.6,0.9-0.3,1.4c0,0,0,0,0,0c0.4,0.4,0.9,0.7,1.5,0.7 c0.7,0,1.4-0.2,2-0.4c0.2,0.7,0.3,1.4,0.4,2.1c0.1,0.5,0.1,1.1,0.2,1.6c-0.1-0.2-0.6-0.8-0.6-0.8c-0.5-0.5-1.8-1.2-2.5-0.9 c-0.5,0.3-0.6,0.9-0.3,1.4c0,0,0,0,0,0c0.4,0.5,0.9,0.7,1.5,0.7c0.7,0,1.3-0.2,1.9-0.4c0,0.2,0,0.5,0.1,0.8 c0.1,0.8,0.1,1.6,0.2,2.4c0,0.3,0.1,0.5,0.1,0.8l-0.5-0.7c-0.5-0.5-1.8-1.2-2.5-0.8c-0.5,0.3-0.6,0.9-0.3,1.4c0,0,0,0,0,0 c0.4,0.5,0.9,0.7,1.5,0.7c0.6,0,1.3-0.2,1.9-0.4c0.1,0.5,0.1,0.9,0.2,1.3c0.1,0.2,0.1,0.4,0.1,0.6l0.2,0.5c0.1,0.4,0.2,0.7,0.4,1 c0.1,0.2,0.1,0.3,0.2,0.5c-0.1-0.3-0.4-0.7-0.4-0.7c-0.4-0.6-1.6-1.5-2.4-1.2c-0.5,0.2-0.8,0.8-0.5,1.3c0,0,0,0,0,0 c0.3,0.5,0.8,0.9,1.4,1c0.7,0.1,1.3,0,2-0.1l0.4,1.1c0.5,1.1,0.9,2.1,1.2,2.7s0.5,1,0.5,1l0,0c0.1,0.1,0.2,0.2,0.4,0.1 c0.1-0.1,0.2-0.2,0.1-0.4C217.6,391.3,217.2,390.9,216.9,390.3z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M211.1,371.2c0.6-0.4,1.1-0.8,1.6-1.3c0.4-0.5,0.5-1.1,0.4-1.6c-0.2-0.5-0.8-0.8-1.3-0.6c0,0,0,0,0,0 c-0.7,0.4-1,1.8-0.9,2.5C210.9,370.2,211.1,371.2,211.1,371.2z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M138.1,392.6c0,0-6.6-2.1-4.7-0.5c0.3,0.3,0.6,0.5,0.8,0.6h19.5l0.6-1.2l0.1-0.3l0.2-0.5l-2.3-1.6l2.5,1.3 l0.6-1.5l-0.5-4.9l0.8,4.5l0.5-1.2l2.2-4.1l-3.6,7.8l5.1-2l-5.3,2.4l-0.6,1.2h21.1c1.1-0.1,2.8-0.5,3.1-1.4 c0.5-1.4-4.5-1.4-4.5-1.4s5.2-2.1,3.3-2.6s-5.2,1.4-5.2,1.4s1.9-4.3-0.5-3.4c-1.2,0.5-2.2,1.5-2.7,2.7c0.2-0.8,0.7-2.8-0.6-2.3 c-0.8,0.4-1.5,1-2,1.8c0.6-1.3,1.2-3.2-1.5-2.5c0.3-3.5-2.2-6.5-5.7-6.9c-6.2-1.1-5.9,7.4-8,9.1s-4.7-0.2-5.6,1.7 c-0.5,0.9-0.8,1.9-0.7,2.9c0,0-3.5-9.3-4-6.7c-0.2,1.8,0.2,3.5,1.2,5c0,0-5.7-7.4-4.5-4.5c0.7,1.7,1.6,3.4,2.6,5 c0,0-7.8-1.9-6.6-0.7S138.1,392.6,138.1,392.6z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M170.6,391.3c-0.1-0.4-0.1-1-0.3-1.8c0-0.2-0.1-0.4-0.1-0.7c-0.4,0.1-0.8,0.1-1.2,0c-0.4-0.1-0.7-0.3-0.8-0.6 c-0.1-0.3,0-0.6,0.3-0.8c0,0,0.1,0,0.1,0c0.5-0.1,1.2,0.5,1.4,0.8c0.1,0.2,0.2,0.3,0.2,0.5l-0.1-0.4c0-0.2-0.1-0.4-0.2-0.6 l-0.1-0.3c0-0.1-0.1-0.2-0.1-0.3s-0.1-0.3-0.2-0.5c-0.4,0.1-0.8,0.2-1.1,0.2c-0.4,0-0.7-0.2-0.9-0.5c-0.2-0.3-0.1-0.6,0.2-0.8 c0,0,0,0,0.1,0c0.5-0.2,1.2,0.3,1.5,0.6l0.1,0.2c-0.1-0.1-0.1-0.3-0.2-0.5c-0.2-0.4-0.4-0.9-0.7-1.3l-0.1-0.3 c-0.4,0.1-0.8,0.2-1.2,0.2c-0.4,0-0.7-0.2-0.9-0.5c-0.2-0.3-0.1-0.6,0.2-0.8c0,0,0,0,0,0c0.5-0.2,1.2,0.3,1.5,0.6 c0,0,0.1,0.1,0.1,0.2c-0.1-0.2-0.2-0.5-0.4-0.7c-0.2-0.4-0.4-0.9-0.5-1.3c-0.4,0.1-0.8,0.2-1.2,0.2c-0.4,0-0.7-0.2-0.9-0.5 c-0.2-0.3-0.1-0.6,0.2-0.8c0,0,0,0,0.1,0c0.5-0.2,1.2,0.3,1.5,0.6l0.3,0.5l0,0c-0.1-0.4-0.2-0.9-0.2-1.3c0-0.4,0-0.8,0-1.2 s0-0.7,0.1-1s0-0.3,0.1-0.5l0,0c0,0-0.2-0.6-0.2-0.6c-0.1-0.4,0-1.3,0.5-1.5c0.3-0.1,0.6,0,0.8,0.3c0,0,0,0,0,0.1 c0.1,0.3,0,0.7-0.2,1c-0.3,0.3-0.6,0.6-0.9,0.8c0,0.1,0,0.3,0,0.5s0,0.6,0,1v0.3c0-0.2,0.1-0.4,0.1-0.4c0.1-0.4,0.6-1.1,1.1-1.2 c0.3,0,0.6,0.3,0.6,0.6c0,0,0,0,0,0.1c-0.1,0.4-0.3,0.7-0.6,0.8c-0.4,0.2-0.8,0.3-1.2,0.3c0,0.2,0,0.5,0.1,0.7 c0,0.4,0.1,0.9,0.3,1.3c0,0,0,0,0,0.1c0-0.1,0-0.6,0.1-0.6c0.1-0.4,0.5-1.2,1-1.3c0.3,0,0.6,0.2,0.6,0.5c0,0,0,0,0,0.1 c0,0.4-0.2,0.7-0.5,0.9c-0.4,0.2-0.8,0.4-1.2,0.4c0.1,0.4,0.3,0.9,0.5,1.3c0.1,0.3,0.3,0.6,0.4,0.9c0-0.1,0-0.6,0-0.6 c0.1-0.4,0.5-1.2,1-1.3c0.3,0,0.6,0.2,0.6,0.5c0,0,0,0,0,0.1c0,0.4-0.2,0.7-0.5,0.9c-0.4,0.2-0.8,0.3-1.2,0.4l0.2,0.4 c0.2,0.4,0.5,0.9,0.7,1.3c0.1,0.1,0.1,0.3,0.2,0.5c0-0.2,0-0.5,0-0.5c0.1-0.4,0.5-1.2,1-1.3c0.3,0,0.6,0.2,0.6,0.5c0,0,0,0,0,0.1 c0,0.4-0.2,0.7-0.5,0.9c-0.3,0.2-0.7,0.3-1.1,0.4c0.1,0.2,0.2,0.5,0.3,0.8l0.1,0.3l0.1,0.3c0.1,0.2,0.1,0.4,0.2,0.6s0,0.2,0.1,0.3 c0-0.2,0-0.5,0-0.5c0-0.4,0.3-1.3,0.8-1.4c0.3-0.1,0.6,0.1,0.7,0.4c0,0,0,0,0,0.1c0,0.4-0.1,0.7-0.4,1c-0.3,0.2-0.7,0.5-1.1,0.6 c0.1,0.2,0.1,0.5,0.2,0.7c0.1,0.7,0.2,1.4,0.3,1.8s0.1,0.7,0.1,0.7l0,0c0,0.1-0.1,0.2-0.2,0.2c-0.1,0-0.2-0.1-0.2-0.1c0,0,0,0,0,0 C170.6,392,170.6,391.7,170.6,391.3z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M167,379.6c-0.4,0-0.8,0-1.2-0.1c-0.3-0.1-0.6-0.4-0.7-0.7c-0.1-0.3,0.1-0.6,0.4-0.7c0,0,0,0,0.1,0 c0.5-0.1,1.1,0.6,1.3,1C166.8,379,167,379.6,167,379.6z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M171.1,391.3c0.2-0.4,0.5-1,0.8-1.6c0.1-0.2,0.2-0.4,0.3-0.6c-0.4-0.2-0.7-0.4-1-0.7c-0.3-0.3-0.4-0.6-0.3-1 c0.1-0.3,0.4-0.5,0.7-0.5c0,0,0,0,0.1,0c0.5,0.2,0.7,1,0.7,1.5c0,0,0,0.4-0.1,0.5l0.1-0.4c0.1-0.2,0.2-0.4,0.2-0.6l0.1-0.3 c0-0.1,0.1-0.2,0.1-0.3s0.1-0.3,0.1-0.5c-0.4-0.1-0.7-0.3-1.1-0.5c-0.3-0.2-0.5-0.6-0.5-0.9c0-0.3,0.3-0.6,0.6-0.6c0,0,0,0,0,0 c0.5,0.1,0.9,0.9,0.9,1.3c0,0,0,0.1,0,0.2c0-0.2,0.1-0.3,0.1-0.5c0.1-0.5,0.1-1,0.2-1.5V384c-0.4-0.1-0.8-0.3-1.1-0.5 c-0.3-0.2-0.5-0.6-0.5-0.9c0-0.3,0.3-0.6,0.6-0.6c0,0,0,0,0.1,0c0.5,0.1,0.9,0.9,0.9,1.3c0,0,0,0.1,0,0.2c0-0.3,0.1-0.5,0.1-0.8 c0.1-0.5,0.2-0.9,0.3-1.3c-0.4-0.1-0.8-0.3-1.1-0.5c-0.3-0.2-0.5-0.5-0.5-0.9c0-0.3,0.3-0.6,0.6-0.6c0,0,0,0,0.1,0 c0.5,0.1,0.9,0.9,0.9,1.3c0,0,0,0.4,0,0.6l0,0c0.1-0.4,0.3-0.8,0.6-1.2c0.2-0.3,0.4-0.7,0.6-1c0.2-0.3,0.4-0.6,0.6-0.8l0.3-0.4l0,0 c0,0,0.2-0.6,0.2-0.6c0.2-0.4,0.8-1.1,1.3-1c0.3,0,0.5,0.3,0.5,0.6c0,0,0,0,0,0.1c-0.1,0.3-0.4,0.6-0.7,0.8 c-0.4,0.1-0.8,0.2-1.2,0.2c-0.1,0.1-0.2,0.2-0.3,0.4c-0.2,0.3-0.4,0.5-0.6,0.8c-0.1,0.1-0.1,0.2-0.2,0.3l0.3-0.3 c0.3-0.3,1.2-0.6,1.6-0.3c0.3,0.2,0.3,0.5,0.2,0.8c0,0,0,0,0,0.1c-0.3,0.3-0.6,0.4-1,0.3c-0.4-0.1-0.8-0.2-1.1-0.4 c-0.1,0.2-0.2,0.4-0.4,0.6c-0.2,0.4-0.4,0.8-0.5,1.2c0,0,0,0,0,0.1l0.4-0.5c0.3-0.3,1.1-0.7,1.6-0.5c0.3,0.1,0.4,0.5,0.2,0.8 c0,0,0,0,0,0.1c-0.2,0.3-0.6,0.4-0.9,0.5c-0.4,0-0.8-0.1-1.2-0.3c-0.1,0.4-0.2,0.9-0.3,1.3c-0.1,0.3-0.1,0.7-0.1,1 c0.1-0.1,0.4-0.5,0.4-0.5c0.3-0.3,1.1-0.7,1.6-0.5c0.3,0.2,0.4,0.5,0.2,0.8c0,0,0,0,0,0.1c-0.2,0.3-0.6,0.4-0.9,0.4 c-0.4,0-0.8-0.1-1.2-0.3c0,0.2,0,0.3-0.1,0.5c0,0.5-0.1,1-0.1,1.5c0,0.2-0.1,0.3-0.1,0.5c0.1-0.1,0.3-0.4,0.3-0.4 c0.3-0.3,1.1-0.7,1.6-0.5c0.3,0.1,0.4,0.5,0.3,0.8c0,0,0,0,0,0.1c-0.2,0.3-0.6,0.4-0.9,0.4c-0.4,0-0.8-0.1-1.2-0.2 c0,0.3-0.1,0.5-0.2,0.8c0,0.1-0.1,0.2-0.1,0.3l-0.1,0.3l-0.2,0.6c0,0.1-0.1,0.2-0.1,0.3c0.1-0.2,0.2-0.4,0.2-0.4 c0.3-0.4,1-0.9,1.5-0.7c0.3,0.1,0.5,0.4,0.4,0.7c0,0,0,0,0,0.1c-0.2,0.3-0.5,0.5-0.9,0.6c-0.4,0-0.8,0-1.2-0.1 c-0.1,0.2-0.2,0.5-0.3,0.7c-0.3,0.7-0.6,1.3-0.7,1.7l-0.3,0.6l0,0c0,0.1-0.1,0.1-0.2,0.1c0,0,0,0,0,0c-0.1,0-0.1-0.1-0.1-0.2 c0,0,0,0,0,0C170.8,391.9,170.9,391.6,171.1,391.3z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M174.7,379.5c-0.4-0.2-0.7-0.5-1-0.8c-0.2-0.3-0.3-0.7-0.2-1c0.1-0.3,0.4-0.5,0.7-0.4c0,0,0,0,0.1,0 c0.4,0.2,0.6,1.1,0.5,1.5C174.8,379,174.7,379.6,174.7,379.5z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M147.9,391.5c0-0.3-0.1-0.8-0.2-1.3c0-0.2-0.1-0.3-0.1-0.5c-0.3,0-0.6,0-0.9,0c-0.3-0.1-0.5-0.2-0.6-0.5 c-0.1-0.2,0-0.5,0.2-0.6c0,0,0,0,0.1,0c0.4-0.1,0.9,0.3,1.1,0.6l0.2,0.4c0-0.1,0-0.2-0.1-0.3s-0.1-0.3-0.1-0.5l-0.1-0.2 c0-0.1,0-0.2-0.1-0.2c0-0.1-0.1-0.2-0.1-0.4c-0.3,0.1-0.6,0.1-0.9,0.1c-0.3,0-0.5-0.2-0.7-0.4c-0.1-0.2-0.1-0.5,0.1-0.6 c0,0,0,0,0,0c0.4-0.1,0.9,0.2,1.1,0.5l0.1,0.1c0-0.1-0.1-0.2-0.2-0.4c-0.2-0.3-0.3-0.7-0.5-1l-0.1-0.2c-0.3,0.1-0.6,0.1-0.9,0.1 c-0.3,0-0.5-0.2-0.7-0.4c-0.1-0.2-0.1-0.5,0.2-0.6c0,0,0,0,0,0c0.4-0.1,0.9,0.2,1.1,0.5l0.1,0.1c-0.1-0.2-0.2-0.4-0.3-0.5 c-0.1-0.3-0.3-0.7-0.4-1c-0.3,0.1-0.6,0.1-0.9,0.1c-0.3,0-0.5-0.2-0.7-0.4c-0.1-0.2-0.1-0.5,0.2-0.6c0,0,0,0,0,0 c0.4-0.1,0.9,0.2,1.1,0.5l0.2,0.4l0,0c-0.1-0.3-0.1-0.7-0.2-1c0-0.3,0-0.6,0-0.9c0-0.3,0-0.5,0-0.8s0-0.2,0-0.3l0,0 c-0.1-0.2-0.1-0.3-0.1-0.5c-0.1-0.3,0-1,0.4-1.2c0.2-0.1,0.5,0,0.6,0.2c0,0,0,0,0,0c0.1,0.3,0,0.5-0.1,0.8 c-0.2,0.2-0.4,0.4-0.7,0.6v0.4c0,0.3,0,0.5,0,0.8v0.2c0-0.1,0.1-0.3,0.1-0.3c0.1-0.3,0.5-0.9,0.9-0.9c0.2,0,0.4,0.2,0.4,0.5 c0,0,0,0,0,0c-0.1,0.3-0.2,0.5-0.5,0.6c-0.3,0.1-0.6,0.2-0.9,0.2c0,0.2,0,0.4,0,0.5c0,0.3,0.1,0.7,0.2,1c0,0,0,0,0,0.1 c0-0.1,0-0.4,0-0.5c0.1-0.3,0.4-0.9,0.8-1c0.2,0,0.5,0.2,0.5,0.4c0,0,0,0,0,0c0,0.3-0.2,0.5-0.4,0.7c-0.3,0.1-0.6,0.3-0.9,0.3 c0.1,0.3,0.2,0.6,0.4,0.9l0.4,0.7c0-0.1,0-0.4,0-0.5c0.1-0.3,0.4-0.9,0.8-1c0.2,0,0.5,0.2,0.5,0.4c0,0,0,0,0,0.1 c0,0.3-0.2,0.5-0.4,0.7c-0.3,0.2-0.6,0.3-0.9,0.3c0,0.1,0.1,0.2,0.2,0.3c0.2,0.3,0.4,0.7,0.5,1c0.1,0.1,0.1,0.2,0.2,0.3 c0-0.1,0-0.4,0-0.4c0.1-0.3,0.4-0.9,0.8-1c0.2,0,0.5,0.2,0.5,0.4c0,0,0,0,0,0.1c0,0.3-0.2,0.5-0.4,0.7c-0.3,0.2-0.5,0.3-0.8,0.3 c0.1,0.2,0.2,0.4,0.2,0.6c0,0.1,0.1,0.2,0.1,0.2l0.1,0.2c0,0.2,0.1,0.3,0.1,0.5c0,0.1,0,0.2,0.1,0.2c0-0.1,0-0.4,0-0.4 c0-0.3,0.2-1,0.6-1.1c0.2-0.1,0.5,0.1,0.5,0.3c0,0,0,0,0,0c0,0.3-0.1,0.5-0.3,0.7c-0.2,0.2-0.5,0.3-0.8,0.5c0,0.2,0.1,0.4,0.1,0.5 c0.1,0.5,0.2,1,0.2,1.3s0.1,0.5,0.1,0.5l0,0c0,0.1,0,0.1-0.1,0.1c0,0,0,0,0,0C148,392,147.9,391.8,147.9,391.5z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M145.2,382.7c-0.3,0-0.6,0-0.9-0.1c-0.3-0.1-0.5-0.3-0.6-0.5c-0.1-0.2,0.1-0.5,0.3-0.5c0,0,0,0,0.1,0 c0.4-0.1,0.8,0.4,1,0.7C145.1,382.2,145.2,382.7,145.2,382.7z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M148.3,391.5c0.1-0.3,0.4-0.7,0.6-1.2c0.1-0.1,0.1-0.3,0.2-0.5c-0.3-0.1-0.5-0.3-0.8-0.5 c-0.2-0.2-0.3-0.5-0.2-0.7c0-0.2,0.3-0.4,0.5-0.4c0,0,0,0,0,0c0.4,0.1,0.6,0.8,0.5,1.1c0,0,0,0.3-0.1,0.4l0.1-0.3 c0.1-0.1,0.1-0.3,0.2-0.5l0.1-0.2c0-0.1,0.1-0.2,0.1-0.2l0.1-0.4c-0.3-0.1-0.6-0.2-0.8-0.4c-0.2-0.2-0.3-0.4-0.4-0.7 c0-0.2,0.2-0.4,0.5-0.4c0,0,0,0,0.1,0c0.4,0.1,0.6,0.7,0.7,1v0.2c0-0.1,0.1-0.3,0.1-0.4c0.1-0.4,0.1-0.7,0.1-1.1c0-0.1,0-0.2,0-0.2 c-0.3-0.1-0.6-0.2-0.8-0.4c-0.2-0.2-0.4-0.4-0.4-0.7c0-0.3,0.2-0.4,0.5-0.4c0,0,0,0,0,0c0.4,0.1,0.7,0.7,0.7,1c0,0,0,0.1,0,0.2 c0-0.2,0-0.4,0.1-0.6c0.1-0.3,0.1-0.7,0.2-1c-0.3-0.1-0.6-0.2-0.8-0.4c-0.2-0.2-0.3-0.4-0.4-0.7c0-0.2,0.2-0.4,0.5-0.4c0,0,0,0,0,0 c0.4,0.1,0.6,0.7,0.7,1c0,0,0,0.3,0,0.4l0,0c0.1-0.3,0.2-0.6,0.4-0.9c0.1-0.3,0.3-0.5,0.5-0.8c0.2-0.2,0.3-0.4,0.5-0.6l0.2-0.3l0,0 c0,0,0.1-0.4,0.1-0.5c0.1-0.3,0.6-0.8,1-0.8c0.2,0,0.4,0.3,0.4,0.5c0,0,0,0,0,0c-0.1,0.3-0.3,0.5-0.5,0.6c-0.3,0.1-0.6,0.1-0.9,0.1 l-0.2,0.3c-0.1,0.2-0.3,0.4-0.4,0.6l-0.1,0.2l0.2-0.2c0.3-0.2,0.9-0.5,1.2-0.3c0.2,0.1,0.3,0.4,0.1,0.6c0,0,0,0,0,0 c-0.2,0.2-0.5,0.3-0.7,0.3c-0.3-0.1-0.6-0.2-0.9-0.3c-0.1,0.1-0.2,0.3-0.3,0.5c-0.2,0.3-0.3,0.6-0.4,0.9v0l0.3-0.4 c0.2-0.2,0.8-0.6,1.2-0.4c0.2,0.1,0.3,0.4,0.2,0.6c0,0,0,0,0,0c-0.2,0.2-0.4,0.3-0.7,0.3c-0.3,0-0.6-0.1-0.9-0.2 c-0.1,0.3-0.2,0.7-0.2,1L150,386c0.1-0.1,0.2-0.2,0.3-0.4c0.2-0.2,0.8-0.6,1.2-0.4c0.2,0.1,0.3,0.4,0.2,0.6c0,0,0,0,0,0 c-0.2,0.2-0.4,0.3-0.7,0.3c-0.3,0-0.6-0.1-0.9-0.2v0.3c0,0.4-0.1,0.8-0.1,1.1c0,0.1,0,0.2-0.1,0.4l0.2-0.3c0.2-0.2,0.8-0.6,1.2-0.4 c0.2,0.1,0.3,0.4,0.2,0.6c0,0,0,0,0,0c-0.2,0.2-0.4,0.3-0.7,0.3c-0.3,0-0.6-0.1-0.9-0.2c0,0.2-0.1,0.4-0.1,0.6c0,0.1,0,0.2-0.1,0.2 l-0.1,0.2l-0.2,0.5c0,0.1-0.1,0.2-0.1,0.2c0.1-0.1,0.2-0.3,0.2-0.3c0.2-0.3,0.7-0.7,1.1-0.6c0.2,0.1,0.4,0.3,0.3,0.6c0,0,0,0,0,0 c-0.1,0.2-0.4,0.4-0.6,0.4c-0.3,0-0.6,0-0.9-0.1l-0.2,0.5c-0.2,0.5-0.4,1-0.6,1.2s-0.2,0.5-0.2,0.5l0,0c0,0.1-0.1,0.1-0.2,0.1 c-0.1,0-0.1-0.1-0.1-0.2c0,0,0,0,0,0C148.1,392,148.1,391.8,148.3,391.5z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M151,382.7c-0.3-0.2-0.5-0.4-0.7-0.6c-0.2-0.2-0.2-0.5-0.2-0.8c0.1-0.2,0.3-0.4,0.6-0.3c0,0,0,0,0,0 c0.3,0.2,0.5,0.8,0.4,1.1C151.1,382.2,151,382.7,151,382.7z"
  })), _rect143 || (_rect143 = /*#__PURE__*/React.createElement("rect", {
    x: 66.4,
    y: 392.2,
    className: "st18",
    width: 174.5,
    height: 6.8
  })), _rect144 || (_rect144 = /*#__PURE__*/React.createElement("rect", {
    x: 138.7,
    y: 392.2,
    className: "st20",
    width: 102.2,
    height: 6.8
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    className: "st55",
    x1: 148.3,
    y1: 396.4,
    x2: 148.3,
    y2: 392.5
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    className: "st55",
    x1: 150.9,
    y1: 392.5,
    x2: 150.9,
    y2: 394.6
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    className: "st55",
    x1: 153.5,
    y1: 392.5,
    x2: 153.5,
    y2: 394.6
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    className: "st55",
    x1: 156.1,
    y1: 392.5,
    x2: 156.1,
    y2: 398
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    className: "st55",
    x1: 159.2,
    y1: 392.5,
    x2: 159.2,
    y2: 395
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    className: "st55",
    x1: 221.1,
    y1: 392.5,
    x2: 221.1,
    y2: 396.4
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    className: "st55",
    x1: 223.7,
    y1: 392.5,
    x2: 223.7,
    y2: 394.6
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    className: "st55",
    x1: 226.3,
    y1: 392.5,
    x2: 226.3,
    y2: 394.6
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    className: "st55",
    x1: 228.9,
    y1: 392.5,
    x2: 228.9,
    y2: 398
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    className: "st55",
    x1: 232.1,
    y1: 392.5,
    x2: 232.1,
    y2: 395
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingBro);
export default __webpack_public_path__ + "static/media/building-bro.77b6ae0c0b44b53b0e166d086214871f.svg";
export { ForwardRef as ReactComponent };